/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: { input: any; output: any; }
  /** A field whose value conforms to the standard internet email address format as specified in HTML Spec: https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address. */
  EmailAddress: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
  /** Password custom scalar type */
  Password: { input: any; output: any; }
  /** A field whose value exists in the standard IANA Time Zone Database: https://www.iana.org/time-zones */
  TimeZone: { input: any; output: any; }
};

export enum Approval_Status {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export enum AgeRange {
  Age_13_17 = 'AGE_13_17',
  Age_18_24 = 'AGE_18_24',
  Age_25_34 = 'AGE_25_34',
  Age_35_44 = 'AGE_35_44',
  Age_45_54 = 'AGE_45_54',
  Age_55Plus = 'AGE_55_PLUS'
}

export type AppConfig = {
  __typename?: 'AppConfig';
  _id: Scalars['ID']['output'];
  config: Scalars['JSON']['output'];
  createdAt: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type Assessment = {
  __typename?: 'Assessment';
  _id: Scalars['ID']['output'];
  assessment?: Maybe<Scalars['JSON']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdById?: Maybe<Scalars['ID']['output']>;
  sessionId: Scalars['ID']['output'];
  traineeId: Scalars['ID']['output'];
  traineeIdUser?: Maybe<User>;
  trainerId: Scalars['ID']['output'];
  trainerIdUser?: Maybe<User>;
  updatedAt: Scalars['DateTime']['output'];
};

export type AssignSessionInput = {
  _id: Scalars['ID']['input'];
  trainerId: Scalars['ID']['input'];
};

export type CachePurgeInput = {
  identifier?: InputMaybe<Scalars['String']['input']>;
  types: Array<Scalars['String']['input']>;
};

export type Card = {
  __typename?: 'Card';
  brand?: Maybe<Scalars['String']['output']>;
  expMonth?: Maybe<Scalars['Int']['output']>;
  expYear?: Maybe<Scalars['Int']['output']>;
  last4?: Maybe<Scalars['String']['output']>;
};

export type CardInput = {
  brand?: InputMaybe<Scalars['String']['input']>;
  expMonth?: InputMaybe<Scalars['Int']['input']>;
  expYear?: InputMaybe<Scalars['Int']['input']>;
  last4?: InputMaybe<Scalars['String']['input']>;
};

export type Certificate = {
  __typename?: 'Certificate';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  status?: Maybe<Scalars['Boolean']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userCertificateCount: Scalars['Int']['output'];
  userCertificates?: Maybe<Array<UserCertificate>>;
};


export type CertificateUserCertificateCountArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type CertificateUserCertificatesArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
};

export type CreateAppConfigInput = {
  config: Scalars['JSON']['input'];
  name: Scalars['String']['input'];
};

export type CreateAssessmentInput = {
  assessment?: InputMaybe<Scalars['JSON']['input']>;
  sessionId: Scalars['ID']['input'];
  traineeId: Scalars['ID']['input'];
  trainerId: Scalars['ID']['input'];
};

export type CreateCertificateInput = {
  status?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['String']['input'];
};

export type CreateMediaInput = {
  createdById?: InputMaybe<Scalars['ID']['input']>;
  path: Scalars['String']['input'];
  status?: InputMaybe<Scalars['Boolean']['input']>;
  thumbnail?: InputMaybe<Scalars['String']['input']>;
  type: MediaType;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateNotificationInput = {
  eventData?: InputMaybe<Scalars['String']['input']>;
  eventType: Scalars['String']['input'];
  isRead?: InputMaybe<Scalars['Boolean']['input']>;
  message: Scalars['String']['input'];
  redirectPath?: InputMaybe<Scalars['String']['input']>;
  sendFromId: Scalars['ID']['input'];
  sendToId: Scalars['ID']['input'];
  status?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

export type CreatePlanInput = {
  order: Scalars['Int']['input'];
  originalPrice?: InputMaybe<Scalars['Float']['input']>;
  planName: Scalars['String']['input'];
  price: Scalars['Float']['input'];
  product_id: Scalars['String']['input'];
  programId: Scalars['ID']['input'];
  recommendedNoOfDays: Scalars['Int']['input'];
  sessionCount: Scalars['Int']['input'];
  status?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateProgramInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  order: Scalars['Int']['input'];
  programLogo?: InputMaybe<Scalars['String']['input']>;
  programName: Scalars['String']['input'];
  status?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreatePurchaseInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  packageName?: InputMaybe<Scalars['String']['input']>;
  paymentDate?: InputMaybe<Scalars['DateTime']['input']>;
  paymentMethod?: InputMaybe<MethodOfPayment>;
  paymentMode?: InputMaybe<Scalars['String']['input']>;
  programId?: InputMaybe<Scalars['ID']['input']>;
  programName?: InputMaybe<Scalars['String']['input']>;
  sessionCount: Scalars['Int']['input'];
  traineeId: Scalars['ID']['input'];
  traineeName?: InputMaybe<Scalars['String']['input']>;
  transactionId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSessionInput = {
  clientFeedback?: InputMaybe<Scalars['String']['input']>;
  clientPerformance?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  exercisePerformed?: InputMaybe<Scalars['String']['input']>;
  isFreeSession?: InputMaybe<Scalars['Boolean']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  programId?: InputMaybe<Scalars['ID']['input']>;
  programName?: InputMaybe<Scalars['String']['input']>;
  roomId?: InputMaybe<Scalars['String']['input']>;
  sessionEndTime: Scalars['DateTime']['input'];
  sessionStartTime: Scalars['DateTime']['input'];
  sessionStatus?: InputMaybe<SessionStatus>;
  specializationId?: InputMaybe<Scalars['ID']['input']>;
  sportId?: InputMaybe<Scalars['ID']['input']>;
  sportName?: InputMaybe<Scalars['String']['input']>;
  targetedMuscle?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  timeZone: Scalars['TimeZone']['input'];
  traineeId: Scalars['ID']['input'];
  traineeName: Scalars['String']['input'];
  trainerFeedback?: InputMaybe<Scalars['String']['input']>;
  trainerId?: InputMaybe<Scalars['ID']['input']>;
  trainingTypeId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateSpecializationInput = {
  icon: Scalars['String']['input'];
  order: Scalars['Int']['input'];
  status?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['String']['input'];
};

export type CreateSportsInput = {
  order?: InputMaybe<Scalars['Int']['input']>;
  sportName?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateTrainerOffDayInput = {
  offDayEndDateTime: Scalars['DateTime']['input'];
  offDayStartDateTime: Scalars['DateTime']['input'];
  trainerId: Scalars['ID']['input'];
};

export type CreateTrainerReccurringShiftInput = {
  slots: Array<DaySlotInput>;
  trainerId: Scalars['ID']['input'];
};

export type CreateTrainerShiftInput = {
  shiftDate: Scalars['DateTime']['input'];
  shiftDayEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  shiftDayStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  timeSlots: Array<TimeSlotInput>;
  trainerId: Scalars['ID']['input'];
};

export type CreateTrainerpaymentInput = {
  amount: Scalars['Float']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  paidOn: Scalars['DateTime']['input'];
  sessionIds: Array<Scalars['ID']['input']>;
  timeZone: Scalars['String']['input'];
  trainerId: Scalars['ID']['input'];
  trainerName?: InputMaybe<Scalars['String']['input']>;
  transactionId: Scalars['String']['input'];
};

export type CreateTrainingTypeInput = {
  icon?: InputMaybe<Scalars['String']['input']>;
  order: Scalars['Int']['input'];
  status: Scalars['Boolean']['input'];
  title: Scalars['String']['input'];
};

export type CreateUserCertificateInput = {
  certificateId?: InputMaybe<Scalars['ID']['input']>;
  filePath: Scalars['String']['input'];
  fileType: UserCertificateType;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};

export type CreateUserInput = {
  about?: InputMaybe<Scalars['String']['input']>;
  ageRange?: InputMaybe<AgeRange>;
  country?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  createdById?: InputMaybe<Scalars['ID']['input']>;
  currentEngagements?: InputMaybe<EngagementTypeInput>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  deleteAccountToken?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  emgContactCountryCode?: InputMaybe<Scalars['String']['input']>;
  emgContactFirstName?: InputMaybe<Scalars['String']['input']>;
  emgContactLastName?: InputMaybe<Scalars['String']['input']>;
  emgContactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  emgContactRelation?: InputMaybe<Scalars['String']['input']>;
  equipments?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  firstName: Scalars['String']['input'];
  fitCurveBalance?: InputMaybe<Scalars['Int']['input']>;
  fitPrimeBalance?: InputMaybe<Scalars['Int']['input']>;
  fitVarsityBalance?: InputMaybe<Scalars['Int']['input']>;
  fitnessGoals?: InputMaybe<Scalars['String']['input']>;
  freeSessionBalance?: InputMaybe<Scalars['Int']['input']>;
  gender?: InputMaybe<Gender>;
  heardAboutUs?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  heightType?: InputMaybe<HeightType>;
  injury?: InputMaybe<EngagementTypeInput>;
  languages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastLoggedIn?: InputMaybe<Scalars['DateTime']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  locationName?: InputMaybe<Scalars['String']['input']>;
  locationPoint?: InputMaybe<LocationPointInput>;
  loginTryCount?: InputMaybe<Scalars['Int']['input']>;
  password?: InputMaybe<Scalars['Password']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumberWithCountryCode?: InputMaybe<Scalars['String']['input']>;
  preferredWorkoutsIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  profileImage?: InputMaybe<Scalars['String']['input']>;
  programs?: InputMaybe<Array<InputMaybe<ProgramDtlsInput>>>;
  rate?: InputMaybe<Scalars['Int']['input']>;
  referralCode?: InputMaybe<Scalars['String']['input']>;
  resetPasswordToken?: InputMaybe<Scalars['String']['input']>;
  role: Role;
  sessionBalance?: InputMaybe<Scalars['Int']['input']>;
  socialMediaLinks?: InputMaybe<Array<InputMaybe<SocialMediaLinkInput>>>;
  specializationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  timezone?: InputMaybe<Scalars['TimeZone']['input']>;
  timezoneCode?: InputMaybe<Scalars['String']['input']>;
  traineeAgeConsent?: InputMaybe<Scalars['Boolean']['input']>;
  traineeLastPositionSelected?: InputMaybe<Scalars['String']['input']>;
  traineeLastProgramSelectedId?: InputMaybe<Scalars['String']['input']>;
  traineeLastSportSelectedId?: InputMaybe<Scalars['ID']['input']>;
  trainerSelectedProgramIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  weight?: InputMaybe<Scalars['Float']['input']>;
  weightType?: InputMaybe<WeightType>;
  workoutPreference?: InputMaybe<Scalars['String']['input']>;
};

export type CreateZoomToken = {
  role?: InputMaybe<Scalars['Int']['input']>;
  sessionId: Scalars['ID']['input'];
};

export type CreateZoomTokenOutPut = {
  __typename?: 'CreateZoomTokenOutPut';
  status: Scalars['Boolean']['output'];
  token: Scalars['String']['output'];
};

export enum Day {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export type DaySlot = {
  __typename?: 'DaySlot';
  _id: Scalars['ID']['output'];
  day: Day;
  timeSlots: Array<TimeSlot>;
};

export type DaySlotInput = {
  day: Day;
  timeSlots: Array<TimeSlotInput>;
};

export type DeviceToken = {
  __typename?: 'DeviceToken';
  _id: Scalars['ID']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deviceId?: Maybe<Scalars['String']['output']>;
  deviceToken?: Maybe<Scalars['String']['output']>;
  deviceType?: Maybe<DeviceType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export enum DeviceType {
  Mobile = 'MOBILE',
  NotProvided = 'NOT_PROVIDED',
  Web = 'WEB'
}

export type EngagementType = {
  __typename?: 'EngagementType';
  description?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type EngagementTypeInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum FileType {
  Document = 'DOCUMENT',
  Photo = 'PHOTO',
  Video = 'VIDEO'
}

export enum Gender {
  Female = 'FEMALE',
  Male = 'MALE',
  NonBinary = 'NON_BINARY'
}

export enum HeightType {
  Centimeter = 'CENTIMETER',
  Inch = 'INCH'
}

export type InviteUserInput = {
  email: Scalars['EmailAddress']['input'];
  firstName: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
};

export type Location = {
  __typename?: 'Location';
  coordinates?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  type?: Maybe<Scalars['String']['output']>;
};

export type LocationPointInput = {
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
};

export type LogInfo = {
  __typename?: 'LogInfo';
  status?: Maybe<Scalars['Boolean']['output']>;
};

export enum LogType {
  In = 'IN',
  Out = 'OUT'
}

export type Login = {
  __typename?: 'Login';
  accessToken: Scalars['String']['output'];
  refreshToken: Scalars['String']['output'];
};

export type LoginInput = {
  email: Scalars['EmailAddress']['input'];
  password: Scalars['Password']['input'];
};

export type Media = {
  __typename?: 'Media';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdById?: Maybe<Scalars['ID']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId?: Maybe<Scalars['ID']['output']>;
};


export type MediaPathArgs = {
  formats?: InputMaybe<Scalars['JSON']['input']>;
};


export type MediaThumbnailArgs = {
  formats?: InputMaybe<Scalars['JSON']['input']>;
};

export enum MediaType {
  Image = 'IMAGE',
  Video = 'VIDEO'
}

export type Mutation = {
  __typename?: 'Mutation';
  assignSession: Session;
  cancelUnassignedSessions?: Maybe<Scalars['Int']['output']>;
  cardSetupIntent: SetupIntentRes;
  changePassword: ResponsePayload;
  createAppConfig: AppConfig;
  createAssessment: Assessment;
  createCertificate: Certificate;
  createCustomer: User;
  createManyCertificate: Array<Certificate>;
  createManyMedia: Array<Media>;
  createManyNotification: Array<Notification>;
  createManyPlan: Array<Plan>;
  createManyPurchase: Array<Purchase>;
  createManySession: Array<Session>;
  createManySpecialization: Array<Specialization>;
  createManyTrainerOffDay: Array<TrainerOffDay>;
  createManyTrainerpayment: Array<Trainerpayment>;
  createManyTrainingType: Array<TrainingType>;
  createManyUser: Array<User>;
  createManyUserCertificate: Array<UserCertificate>;
  createMedia: Media;
  createNotification: Notification;
  createPlan: Plan;
  createProgram: Program;
  createPurchase: Purchase;
  createSession: Session;
  createSpecialization: Specialization;
  createSports: Sports;
  createTrainer: User;
  createTrainerOffDay: TrainerOffDay;
  createTrainerReccurringShift: TrainerReccurringShift;
  createTrainerShift: TrainerShift;
  createTrainerpayment: Trainerpayment;
  createTrainingType: TrainingType;
  createUser: User;
  createUserCertificate: UserCertificate;
  createZoomToken: CreateZoomTokenOutPut;
  deleteAccount: User;
  deleteAppConfig: AppConfig;
  deleteAssessment: Assessment;
  deleteCertificate: Certificate;
  deleteManyAssessment: Array<Assessment>;
  deleteManyCertificate: Array<Certificate>;
  deleteManyMedia: Array<Media>;
  deleteManyNotification: Array<Notification>;
  deleteManyPlan: Array<Plan>;
  deleteManyPurchase: Array<Purchase>;
  deleteManySession: Array<Session>;
  deleteManySpecialization: Array<Specialization>;
  deleteManyTrainerOffDay: Array<TrainerOffDay>;
  deleteManyTrainerpayment: Array<Trainerpayment>;
  deleteManyTrainingType: Array<TrainingType>;
  deleteManyUserCertificate: Array<UserCertificate>;
  deleteMedia: Media;
  deleteNotification: Notification;
  deletePlan: Plan;
  deleteProgram: Program;
  deletePurchase: Purchase;
  deleteSession: Session;
  deleteSpecialization: Specialization;
  deleteSports: Sports;
  deleteTrainerOffDay: TrainerOffDay;
  deleteTrainerpayment: Trainerpayment;
  deleteTrainingType: TrainingType;
  deleteUser: User;
  deleteUserCertificate: UserCertificate;
  forgetPassword: ResponsePayload;
  generateAccessToken: TokenRes;
  generateFirebaseToken: TokenRes;
  generateOtp: ResponsePayload;
  generateUserIdentityToken: Scalars['String']['output'];
  generateUserPrivilegeToken: Scalars['String']['output'];
  insertReccuringShifts?: Maybe<Scalars['Int']['output']>;
  inviteUser: User;
  login: Login;
  logout: ResponsePayload;
  processSuccessfullPayment: ResponsePayload;
  productPaymentIntent: ProductPaymentIntentRes;
  readAllNotification: ResponsePayload;
  readOneNotification: ResponsePayload;
  requestDeleteAccount: ResponsePayload;
  resetPassword: ResponsePayload;
  updateAppConfig: AppConfig;
  updateAssessment: Assessment;
  updateCertificate: Certificate;
  updateCompletedSessions?: Maybe<Scalars['Int']['output']>;
  updateCustomer: User;
  updateDeviceToken: DeviceToken;
  updateManyAssessment: Array<Assessment>;
  updateManyCertificate: Array<Certificate>;
  updateManyMedia: Array<Media>;
  updateManyNotification: Array<Notification>;
  updateManyPlan: Array<Plan>;
  updateManyPurchase: Array<Purchase>;
  updateManySession: Array<Session>;
  updateManySpecialization: Array<Specialization>;
  updateManyTrainerOffDay: Array<TrainerOffDay>;
  updateManyTrainerpayment: Array<Trainerpayment>;
  updateManyTrainingType: Array<TrainingType>;
  updateManyUser: Array<User>;
  updateManyUserCertificate: Array<UserCertificate>;
  updateMedia: Media;
  updateNoShowSessions?: Maybe<Scalars['Int']['output']>;
  updateNotification: Notification;
  updatePlan: Plan;
  updateProgram: Program;
  updatePurchase: Purchase;
  updateSession: Session;
  updateSpecialization: Specialization;
  updateSports: Sports;
  updateTrainer: User;
  updateTrainerOffDay: TrainerOffDay;
  updateTrainerShift: TrainerShift;
  updateTrainerpayment: Trainerpayment;
  updateTrainingType: TrainingType;
  updateUser: User;
  updateUserCertificate: UserCertificate;
  verifyOtp: Login;
  verifyReceipt?: Maybe<Receipt>;
  viewAccount: User;
};


export type MutationAssignSessionArgs = {
  data: AssignSessionInput;
};


export type MutationChangePasswordArgs = {
  newPassword: Scalars['Password']['input'];
  oldPassword: Scalars['Password']['input'];
};


export type MutationCreateAppConfigArgs = {
  data: CreateAppConfigInput;
};


export type MutationCreateAssessmentArgs = {
  data: CreateAssessmentInput;
};


export type MutationCreateCertificateArgs = {
  data: CreateCertificateInput;
};


export type MutationCreateCustomerArgs = {
  data: CreateUserInput;
};


export type MutationCreateManyCertificateArgs = {
  datas: Array<CreateCertificateInput>;
};


export type MutationCreateManyMediaArgs = {
  datas: Array<CreateMediaInput>;
};


export type MutationCreateManyNotificationArgs = {
  datas: Array<CreateNotificationInput>;
};


export type MutationCreateManyPlanArgs = {
  datas: Array<CreatePlanInput>;
};


export type MutationCreateManyPurchaseArgs = {
  datas: Array<CreatePurchaseInput>;
};


export type MutationCreateManySessionArgs = {
  datas: Array<CreateSessionInput>;
};


export type MutationCreateManySpecializationArgs = {
  datas: Array<CreateSpecializationInput>;
};


export type MutationCreateManyTrainerOffDayArgs = {
  datas: Array<CreateTrainerOffDayInput>;
};


export type MutationCreateManyTrainerpaymentArgs = {
  datas: Array<CreateTrainerpaymentInput>;
};


export type MutationCreateManyTrainingTypeArgs = {
  datas: Array<CreateTrainingTypeInput>;
};


export type MutationCreateManyUserArgs = {
  datas: Array<CreateUserInput>;
};


export type MutationCreateManyUserCertificateArgs = {
  datas: Array<CreateUserCertificateInput>;
};


export type MutationCreateMediaArgs = {
  data: CreateMediaInput;
};


export type MutationCreateNotificationArgs = {
  data: CreateNotificationInput;
};


export type MutationCreatePlanArgs = {
  data: CreatePlanInput;
};


export type MutationCreateProgramArgs = {
  data: CreateProgramInput;
};


export type MutationCreatePurchaseArgs = {
  data: CreatePurchaseInput;
};


export type MutationCreateSessionArgs = {
  data: CreateSessionInput;
};


export type MutationCreateSpecializationArgs = {
  data: CreateSpecializationInput;
};


export type MutationCreateSportsArgs = {
  data: CreateSportsInput;
};


export type MutationCreateTrainerArgs = {
  data: CreateUserInput;
};


export type MutationCreateTrainerOffDayArgs = {
  data: CreateTrainerOffDayInput;
};


export type MutationCreateTrainerReccurringShiftArgs = {
  data: CreateTrainerReccurringShiftInput;
};


export type MutationCreateTrainerShiftArgs = {
  data: CreateTrainerShiftInput;
};


export type MutationCreateTrainerpaymentArgs = {
  data: CreateTrainerpaymentInput;
};


export type MutationCreateTrainingTypeArgs = {
  data: CreateTrainingTypeInput;
};


export type MutationCreateUserArgs = {
  data: CreateUserInput;
};


export type MutationCreateUserCertificateArgs = {
  data: CreateUserCertificateInput;
};


export type MutationCreateZoomTokenArgs = {
  data: CreateZoomToken;
};


export type MutationDeleteAccountArgs = {
  deleteTicket: Scalars['String']['input'];
};


export type MutationDeleteAppConfigArgs = {
  _id: Scalars['ID']['input'];
};


export type MutationDeleteAssessmentArgs = {
  _id: Scalars['ID']['input'];
};


export type MutationDeleteCertificateArgs = {
  _id: Scalars['ID']['input'];
};


export type MutationDeleteManyAssessmentArgs = {
  filter: Scalars['JSON']['input'];
};


export type MutationDeleteManyCertificateArgs = {
  filter: Scalars['JSON']['input'];
};


export type MutationDeleteManyMediaArgs = {
  filter: Scalars['JSON']['input'];
};


export type MutationDeleteManyNotificationArgs = {
  filter: Scalars['JSON']['input'];
};


export type MutationDeleteManyPlanArgs = {
  filter: Scalars['JSON']['input'];
};


export type MutationDeleteManyPurchaseArgs = {
  filter: Scalars['JSON']['input'];
};


export type MutationDeleteManySessionArgs = {
  filter: Scalars['JSON']['input'];
};


export type MutationDeleteManySpecializationArgs = {
  filter: Scalars['JSON']['input'];
};


export type MutationDeleteManyTrainerOffDayArgs = {
  filter: Scalars['JSON']['input'];
};


export type MutationDeleteManyTrainerpaymentArgs = {
  filter: Scalars['JSON']['input'];
};


export type MutationDeleteManyTrainingTypeArgs = {
  filter: Scalars['JSON']['input'];
};


export type MutationDeleteManyUserCertificateArgs = {
  filter: Scalars['JSON']['input'];
};


export type MutationDeleteMediaArgs = {
  _id: Scalars['ID']['input'];
};


export type MutationDeleteNotificationArgs = {
  _id: Scalars['ID']['input'];
};


export type MutationDeletePlanArgs = {
  _id: Scalars['ID']['input'];
};


export type MutationDeleteProgramArgs = {
  _id: Scalars['ID']['input'];
};


export type MutationDeletePurchaseArgs = {
  _id: Scalars['ID']['input'];
};


export type MutationDeleteSessionArgs = {
  _id: Scalars['ID']['input'];
};


export type MutationDeleteSpecializationArgs = {
  _id: Scalars['ID']['input'];
};


export type MutationDeleteSportsArgs = {
  _id: Scalars['ID']['input'];
};


export type MutationDeleteTrainerOffDayArgs = {
  _id: Scalars['ID']['input'];
};


export type MutationDeleteTrainerpaymentArgs = {
  _id: Scalars['ID']['input'];
};


export type MutationDeleteTrainingTypeArgs = {
  _id: Scalars['ID']['input'];
};


export type MutationDeleteUserArgs = {
  _id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteUserCertificateArgs = {
  _id: Scalars['ID']['input'];
};


export type MutationForgetPasswordArgs = {
  email: Scalars['EmailAddress']['input'];
};


export type MutationGenerateAccessTokenArgs = {
  refreshToken: Scalars['String']['input'];
};


export type MutationGenerateOtpArgs = {
  countryCode: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};


export type MutationGenerateUserPrivilegeTokenArgs = {
  roomId: Scalars['String']['input'];
};


export type MutationInviteUserArgs = {
  data: InviteUserInput;
};


export type MutationLoginArgs = {
  data: LoginInput;
};


export type MutationProcessSuccessfullPaymentArgs = {
  _id: Scalars['ID']['input'];
};


export type MutationProductPaymentIntentArgs = {
  data: ProductPaymentIntentInput;
};


export type MutationReadOneNotificationArgs = {
  _id: Scalars['ID']['input'];
};


export type MutationRequestDeleteAccountArgs = {
  email: Scalars['EmailAddress']['input'];
  reason: Scalars['String']['input'];
};


export type MutationResetPasswordArgs = {
  newPassword: Scalars['Password']['input'];
  resetTicket: Scalars['String']['input'];
  type: ResetPasswordType;
};


export type MutationUpdateAppConfigArgs = {
  data: UpdateAppConfigInput;
};


export type MutationUpdateAssessmentArgs = {
  data: UpdateAssessmentInput;
};


export type MutationUpdateCertificateArgs = {
  data: UpdateCertificateInput;
};


export type MutationUpdateCustomerArgs = {
  data: UpdateUserInput;
};


export type MutationUpdateDeviceTokenArgs = {
  data: UpdateDeviceTokenInput;
};


export type MutationUpdateManyAssessmentArgs = {
  datas: Array<UpdateAssessmentInput>;
};


export type MutationUpdateManyCertificateArgs = {
  datas: Array<UpdateCertificateInput>;
};


export type MutationUpdateManyMediaArgs = {
  datas: Array<UpdateMediaInput>;
};


export type MutationUpdateManyNotificationArgs = {
  datas: Array<UpdateNotificationInput>;
};


export type MutationUpdateManyPlanArgs = {
  datas: Array<UpdatePlanInput>;
};


export type MutationUpdateManyPurchaseArgs = {
  datas: Array<UpdatePurchaseInput>;
};


export type MutationUpdateManySessionArgs = {
  datas: Array<UpdateSessionInput>;
};


export type MutationUpdateManySpecializationArgs = {
  datas: Array<UpdateSpecializationInput>;
};


export type MutationUpdateManyTrainerOffDayArgs = {
  datas: Array<UpdateTrainerOffDayInput>;
};


export type MutationUpdateManyTrainerpaymentArgs = {
  datas: Array<UpdateTrainerpaymentInput>;
};


export type MutationUpdateManyTrainingTypeArgs = {
  datas: Array<UpdateTrainingTypeInput>;
};


export type MutationUpdateManyUserArgs = {
  datas: Array<UpdateUserInput>;
};


export type MutationUpdateManyUserCertificateArgs = {
  datas: Array<UpdateUserCertificateInput>;
};


export type MutationUpdateMediaArgs = {
  data: UpdateMediaInput;
};


export type MutationUpdateNotificationArgs = {
  data: UpdateNotificationInput;
};


export type MutationUpdatePlanArgs = {
  data: UpdatePlanInput;
};


export type MutationUpdateProgramArgs = {
  data: UpdateProgramInput;
};


export type MutationUpdatePurchaseArgs = {
  data: UpdatePurchaseInput;
};


export type MutationUpdateSessionArgs = {
  data: UpdateSessionInput;
};


export type MutationUpdateSpecializationArgs = {
  data: UpdateSpecializationInput;
};


export type MutationUpdateSportsArgs = {
  data: UpdateSportsInput;
};


export type MutationUpdateTrainerArgs = {
  data: UpdateUserInput;
};


export type MutationUpdateTrainerOffDayArgs = {
  data: UpdateTrainerOffDayInput;
};


export type MutationUpdateTrainerShiftArgs = {
  data: UpdateTrainerShiftInput;
};


export type MutationUpdateTrainerpaymentArgs = {
  data: UpdateTrainerpaymentInput;
};


export type MutationUpdateTrainingTypeArgs = {
  data: UpdateTrainingTypeInput;
};


export type MutationUpdateUserArgs = {
  data: UpdateUserInput;
};


export type MutationUpdateUserCertificateArgs = {
  data: UpdateUserCertificateInput;
};


export type MutationVerifyOtpArgs = {
  countryCode: Scalars['String']['input'];
  otp: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};


export type MutationVerifyReceiptArgs = {
  data: VerifyReceiptInput;
};


export type MutationViewAccountArgs = {
  deleteTicket: Scalars['String']['input'];
};

export type Notification = {
  __typename?: 'Notification';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  eventData?: Maybe<Scalars['String']['output']>;
  eventType: Scalars['String']['output'];
  isRead?: Maybe<Scalars['Boolean']['output']>;
  message: Scalars['String']['output'];
  redirectPath?: Maybe<Scalars['String']['output']>;
  sendFromId: Scalars['ID']['output'];
  sendFromIdUser?: Maybe<User>;
  sendToId: Scalars['ID']['output'];
  sendToIdUser?: Maybe<User>;
  status?: Maybe<Scalars['Boolean']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['ID']['output'];
  userIdUser?: Maybe<User>;
};

export type ParticipantLogs = {
  __typename?: 'ParticipantLogs';
  LogType?: Maybe<LogType>;
  participantId?: Maybe<Scalars['ID']['output']>;
  time?: Maybe<Scalars['DateTime']['output']>;
};

export enum PaymentMethodType {
  BankAccount = 'BANK_ACCOUNT',
  Card = 'CARD'
}

export enum PaymentStatus {
  Canceled = 'CANCELED',
  Disputed = 'DISPUTED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Refunded = 'REFUNDED',
  RequiresAction = 'REQUIRES_ACTION',
  Succeeded = 'SUCCEEDED'
}

export type Plan = {
  __typename?: 'Plan';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  order: Scalars['Int']['output'];
  originalPrice?: Maybe<Scalars['Float']['output']>;
  planName: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  product_id: Scalars['String']['output'];
  program: Program;
  programId: Scalars['ID']['output'];
  recommendedNoOfDays: Scalars['Int']['output'];
  sessionCount: Scalars['Int']['output'];
  status?: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ProductPaymentIntentInput = {
  planId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type ProductPaymentIntentRes = {
  __typename?: 'ProductPaymentIntentRes';
  customerSessionSecret: Scalars['String']['output'];
  paymentIntentSecret: Scalars['String']['output'];
  stripeCustomerId: Scalars['String']['output'];
};

export type Program = {
  __typename?: 'Program';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  order: Scalars['Int']['output'];
  programLogo?: Maybe<Scalars['String']['output']>;
  programName: Scalars['String']['output'];
  status?: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ProgramDtls = {
  __typename?: 'ProgramDtls';
  _id?: Maybe<Scalars['ID']['output']>;
  fields?: Maybe<FieldsDtls>;
  joinedAt?: Maybe<Scalars['DateTime']['output']>;
  programId?: Maybe<Scalars['ID']['output']>;
  programName?: Maybe<Scalars['String']['output']>;
};

export type ProgramDtlsInput = {
  fields?: InputMaybe<FieldsDtlsInput>;
  joinedAt?: InputMaybe<Scalars['DateTime']['input']>;
  programId?: InputMaybe<Scalars['ID']['input']>;
  programName?: InputMaybe<Scalars['String']['input']>;
};

export type Purchase = {
  __typename?: 'Purchase';
  _id: Scalars['ID']['output'];
  amount: Scalars['Float']['output'];
  cardEnd?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currencyType?: Maybe<Scalars['String']['output']>;
  localizedPrice?: Maybe<Scalars['String']['output']>;
  packageName?: Maybe<Scalars['String']['output']>;
  paymentDate: Scalars['DateTime']['output'];
  paymentMethod?: Maybe<MethodOfPayment>;
  paymentMode?: Maybe<Scalars['String']['output']>;
  planPrice?: Maybe<Scalars['Float']['output']>;
  programDetails?: Maybe<Program>;
  programId?: Maybe<Scalars['ID']['output']>;
  programName?: Maybe<Scalars['String']['output']>;
  sessionCount: Scalars['Int']['output'];
  sessionSubscribed?: Maybe<Scalars['Int']['output']>;
  traineeDetails?: Maybe<User>;
  traineeId: Scalars['ID']['output'];
  traineeName?: Maybe<Scalars['String']['output']>;
  transactionId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type PurchaseReport = {
  __typename?: 'PurchaseReport';
  _id?: Maybe<Scalars['ID']['output']>;
  lastPurchase?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  totalComplimentarySessions?: Maybe<Scalars['Int']['output']>;
  totalPaidSessions?: Maybe<Scalars['Int']['output']>;
  traineeDetails?: Maybe<User>;
};

export type Query = {
  __typename?: 'Query';
  appMainHello: Scalars['String']['output'];
  customerPurchaseReport: Array<Maybe<PurchaseReport>>;
  customerPurchaseReportCount: Scalars['Int']['output'];
  getAllAppConfig: Array<Maybe<AppConfig>>;
  getAllAppConfigCount: Scalars['Int']['output'];
  getAllAssessment: Array<Maybe<Assessment>>;
  getAllAssessmentCount: Scalars['Int']['output'];
  getAllCertificate: Array<Maybe<Certificate>>;
  getAllCertificateCount: Scalars['Int']['output'];
  getAllCustomers: Array<Maybe<User>>;
  getAllCustomersCount: Scalars['Int']['output'];
  getAllDeviceToken: Array<Maybe<DeviceToken>>;
  getAllDeviceTokenCount: Scalars['Int']['output'];
  getAllMatchingTrainers: Array<Maybe<User>>;
  getAllMatchingTrainersCount: Scalars['Int']['output'];
  getAllMedia: Array<Maybe<Media>>;
  getAllMediaCount: Scalars['Int']['output'];
  getAllNotification: Array<Maybe<Notification>>;
  getAllNotificationCount: Scalars['Int']['output'];
  getAllPlan: Array<Maybe<Plan>>;
  getAllPlanCount: Scalars['Int']['output'];
  getAllProgram: Array<Maybe<Program>>;
  getAllProgramCount: Scalars['Int']['output'];
  getAllPurchase: Array<Maybe<Purchase>>;
  getAllPurchaseCount: Scalars['Int']['output'];
  getAllSession: Array<Maybe<Session>>;
  getAllSessionCount: Scalars['Int']['output'];
  getAllSpecialization: Array<Maybe<Specialization>>;
  getAllSpecializationCount: Scalars['Int']['output'];
  getAllSports: Array<Maybe<Sports>>;
  getAllSportsCount: Scalars['Int']['output'];
  getAllTrainerOffDay: Array<Maybe<TrainerOffDay>>;
  getAllTrainerOffDayCount: Scalars['Int']['output'];
  getAllTrainerShift: Array<Maybe<TrainerShift>>;
  getAllTrainerShiftCount: Scalars['Int']['output'];
  getAllTrainerpayment: Array<Maybe<Trainerpayment>>;
  getAllTrainerpaymentCount: Scalars['Int']['output'];
  getAllTrainers: Array<Maybe<User>>;
  getAllTrainersCount: Scalars['Int']['output'];
  getAllTrainingType: Array<Maybe<TrainingType>>;
  getAllTrainingTypeCount: Scalars['Int']['output'];
  getAllUser: Array<Maybe<User>>;
  getAllUserCertificate: Array<Maybe<UserCertificate>>;
  getAllUserCertificateCount: Scalars['Int']['output'];
  getAllUserCount: Scalars['Int']['output'];
  getAppConfigById?: Maybe<AppConfig>;
  getAssessmentById?: Maybe<Assessment>;
  getCertificateById?: Maybe<Certificate>;
  getCurrentUser?: Maybe<User>;
  getDownloadSignedUrl: Scalars['String']['output'];
  getLogInfo?: Maybe<LogInfo>;
  getMediaById?: Maybe<Media>;
  getMySavedCards: SavedCards;
  getNotesFromPreviosSessions?: Maybe<Array<Maybe<Session>>>;
  getNotificationById?: Maybe<Notification>;
  getOneAppConfig?: Maybe<AppConfig>;
  getOneAssessment?: Maybe<Assessment>;
  getOneCertificate?: Maybe<Certificate>;
  getOneMedia?: Maybe<Media>;
  getOneNotification?: Maybe<Notification>;
  getOnePlan?: Maybe<Plan>;
  getOneProgram?: Maybe<Program>;
  getOnePurchase?: Maybe<Purchase>;
  getOneSession?: Maybe<Session>;
  getOneSpecialization?: Maybe<Specialization>;
  getOneSports?: Maybe<Sports>;
  getOneTrainerOffDay?: Maybe<TrainerOffDay>;
  getOneTrainerReccurringShift?: Maybe<TrainerReccurringShift>;
  getOneTrainerShift?: Maybe<TrainerShift>;
  getOneTrainerpayment?: Maybe<Trainerpayment>;
  getOneTrainingType?: Maybe<TrainingType>;
  getOneUser?: Maybe<User>;
  getOneUserCertificate?: Maybe<UserCertificate>;
  getOverAllAssessment?: Maybe<Scalars['JSON']['output']>;
  getPlanById?: Maybe<Plan>;
  getProgramById?: Maybe<Program>;
  getPurchaseById?: Maybe<Purchase>;
  getSessionById?: Maybe<Session>;
  getSignedUrl: S3UrlPayload;
  getSpecializationById?: Maybe<Specialization>;
  getSportsById?: Maybe<Sports>;
  getSubscriptionHeader?: Maybe<SubscriptionHeader>;
  getTotalRevenue: Scalars['Float']['output'];
  getTraineeSessionReport?: Maybe<Array<Maybe<SessionReport>>>;
  getTraineeSessionReportCount: Scalars['Int']['output'];
  getTrainerOffDayById?: Maybe<TrainerOffDay>;
  getTrainerPaymentsAdmin?: Maybe<Array<Maybe<Session>>>;
  getTrainerPaymentsAdminCount: Scalars['Int']['output'];
  getTrainerSessionReport?: Maybe<Array<Maybe<SessionReport>>>;
  getTrainerSessionReportCount: Scalars['Int']['output'];
  getTrainerShiftById?: Maybe<TrainerShift>;
  getTrainerTotalAmount: Scalars['Int']['output'];
  getTrainerpaymentById?: Maybe<Trainerpayment>;
  getTrainingTypeById?: Maybe<TrainingType>;
  getUserById?: Maybe<User>;
  getUserCertificateById?: Maybe<UserCertificate>;
  listTrainerTotalTrainingSessions?: Maybe<Array<Maybe<TrianerTotalTrainingSessions>>>;
  listTrainerTotalTrainingSessionsCount: Scalars['Int']['output'];
  meetOurTrainers: Array<Maybe<User>>;
  trainerCapacityReport?: Maybe<Array<Maybe<TrainerCapacityRpt>>>;
  trainerCapacityReportCount: Scalars['Int']['output'];
  trainerPaymentHistory: Array<Maybe<TrainerPaymentHistory>>;
  trainerPaymentHistoryCount: Scalars['Int']['output'];
};


export type QueryCustomerPurchaseReportArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryCustomerPurchaseReportCountArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetAllAppConfigArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryGetAllAppConfigCountArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetAllAssessmentArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryGetAllAssessmentCountArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetAllCertificateArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryGetAllCertificateCountArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetAllCustomersArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryGetAllCustomersCountArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetAllDeviceTokenArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryGetAllDeviceTokenCountArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryGetAllMatchingTrainersArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sessionId: Scalars['ID']['input'];
  sort?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryGetAllMatchingTrainersCountArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sessionId: Scalars['ID']['input'];
};


export type QueryGetAllMediaArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryGetAllMediaCountArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetAllNotificationArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryGetAllNotificationCountArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetAllPlanArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryGetAllPlanCountArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetAllProgramArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryGetAllProgramCountArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetAllPurchaseArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryGetAllPurchaseCountArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetAllSessionArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryGetAllSessionCountArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetAllSpecializationArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryGetAllSpecializationCountArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetAllSportsArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryGetAllSportsCountArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetAllTrainerOffDayArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryGetAllTrainerOffDayCountArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetAllTrainerShiftArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryGetAllTrainerShiftCountArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetAllTrainerpaymentArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryGetAllTrainerpaymentCountArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetAllTrainersArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryGetAllTrainersCountArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetAllTrainingTypeArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryGetAllTrainingTypeCountArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetAllUserArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryGetAllUserCertificateArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryGetAllUserCertificateCountArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetAllUserCountArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetAppConfigByIdArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryGetAssessmentByIdArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryGetCertificateByIdArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryGetDownloadSignedUrlArgs = {
  key: Scalars['String']['input'];
};


export type QueryGetLogInfoArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryGetMediaByIdArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryGetNotesFromPreviosSessionsArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryGetNotificationByIdArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryGetOneAppConfigArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryGetOneAssessmentArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryGetOneCertificateArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryGetOneMediaArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryGetOneNotificationArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryGetOnePlanArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryGetOneProgramArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryGetOnePurchaseArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryGetOneSessionArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryGetOneSpecializationArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryGetOneSportsArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryGetOneTrainerOffDayArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryGetOneTrainerReccurringShiftArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryGetOneTrainerShiftArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryGetOneTrainerpaymentArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryGetOneTrainingTypeArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryGetOneUserArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryGetOneUserCertificateArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryGetOverAllAssessmentArgs = {
  traineeId: Scalars['ID']['input'];
};


export type QueryGetPlanByIdArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryGetProgramByIdArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryGetPurchaseByIdArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryGetSessionByIdArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryGetSignedUrlArgs = {
  fileName: Scalars['String']['input'];
  fileType: FileType;
};


export type QueryGetSpecializationByIdArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryGetSportsByIdArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryGetSubscriptionHeaderArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryGetTotalRevenueArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryGetTraineeSessionReportArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryGetTraineeSessionReportCountArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetTrainerOffDayByIdArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryGetTrainerPaymentsAdminArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryGetTrainerPaymentsAdminCountArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetTrainerSessionReportArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryGetTrainerSessionReportCountArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetTrainerShiftByIdArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryGetTrainerTotalAmountArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetTrainerpaymentByIdArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryGetTrainingTypeByIdArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryGetUserByIdArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryGetUserCertificateByIdArgs = {
  _id: Scalars['ID']['input'];
};


export type QueryListTrainerTotalTrainingSessionsArgs = {
  fromDate: Scalars['DateTime']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  toDate: Scalars['DateTime']['input'];
};


export type QueryListTrainerTotalTrainingSessionsCountArgs = {
  fromDate: Scalars['DateTime']['input'];
  toDate: Scalars['DateTime']['input'];
};


export type QueryMeetOurTrainersArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTrainerCapacityReportArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTrainerCapacityReportCountArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTrainerPaymentHistoryArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryTrainerPaymentHistoryCountArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export enum ResetPasswordType {
  ForgetPassword = 'FORGET_PASSWORD',
  Invitation = 'INVITATION'
}

export type ResponsePayload = {
  __typename?: 'ResponsePayload';
  message: Scalars['String']['output'];
  status: Scalars['Int']['output'];
};

export enum Role {
  Coach = 'COACH',
  SuperAdmin = 'SUPER_ADMIN',
  Trainee = 'TRAINEE',
  Trainer = 'TRAINER'
}

export type S3UrlPayload = {
  __typename?: 'S3UrlPayload';
  key: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type SavedCards = {
  __typename?: 'SavedCards';
  cards?: Maybe<Array<Maybe<Card>>>;
  stripeCustomerId: Scalars['String']['output'];
};

export type Session = {
  __typename?: 'Session';
  _id: Scalars['ID']['output'];
  appUserFriendliness?: Maybe<Scalars['String']['output']>;
  assesment?: Maybe<Assessment>;
  clientFeedback?: Maybe<Scalars['String']['output']>;
  clientPerformance?: Maybe<Scalars['String']['output']>;
  continuationLikelihood?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdById?: Maybe<Scalars['ID']['output']>;
  createdByIdUser?: Maybe<User>;
  duration?: Maybe<Scalars['Int']['output']>;
  exercisePerformed?: Maybe<Scalars['String']['output']>;
  futureSessionImprovement?: Maybe<Scalars['String']['output']>;
  isFreeSession?: Maybe<Scalars['Boolean']['output']>;
  lastTrainerDtls?: Maybe<User>;
  note?: Maybe<Scalars['String']['output']>;
  paidSessions?: Maybe<Scalars['Int']['output']>;
  participantLogs?: Maybe<ParticipantLogs>;
  position?: Maybe<Scalars['String']['output']>;
  programDetails?: Maybe<Program>;
  programId?: Maybe<Scalars['ID']['output']>;
  programName?: Maybe<Scalars['String']['output']>;
  roomId?: Maybe<Scalars['String']['output']>;
  schedulingConvenience?: Maybe<Scalars['String']['output']>;
  sessionEndTime: Scalars['DateTime']['output'];
  sessionExpectationMet?: Maybe<Scalars['String']['output']>;
  sessionLikes?: Maybe<Scalars['String']['output']>;
  sessionStartTime: Scalars['DateTime']['output'];
  sessionStatus: SessionStatus;
  sessionUniqId?: Maybe<Scalars['String']['output']>;
  specializationId?: Maybe<Scalars['ID']['output']>;
  specializationIdSpecialization?: Maybe<Specialization>;
  sportId?: Maybe<Scalars['ID']['output']>;
  sportName?: Maybe<Scalars['String']['output']>;
  sportsDetails?: Maybe<Sports>;
  status?: Maybe<Scalars['Boolean']['output']>;
  subscriptionId?: Maybe<Scalars['ID']['output']>;
  subscriptionType: Scalars['String']['output'];
  targetedMuscle?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  technicalIssuesDescription?: Maybe<Scalars['String']['output']>;
  technicalIssuesEncountered?: Maybe<Scalars['Boolean']['output']>;
  timeZone: Scalars['TimeZone']['output'];
  totalPaidAmount?: Maybe<Scalars['Int']['output']>;
  totalSessions?: Maybe<Scalars['Int']['output']>;
  totalUnpaidAmount?: Maybe<Scalars['Int']['output']>;
  traineeId: Scalars['ID']['output'];
  traineeIdUser?: Maybe<User>;
  traineeName?: Maybe<Scalars['String']['output']>;
  traineeRating?: Maybe<Scalars['Int']['output']>;
  trainerAssignedDateTime?: Maybe<Scalars['DateTime']['output']>;
  trainerCommunicationEffectiveness?: Maybe<Scalars['String']['output']>;
  trainerExpertiseRating?: Maybe<Scalars['String']['output']>;
  trainerFeedback?: Maybe<Scalars['String']['output']>;
  trainerId?: Maybe<Scalars['ID']['output']>;
  trainerIdUser?: Maybe<User>;
  trainerName?: Maybe<Scalars['String']['output']>;
  trainerPaymentStatus?: Maybe<Scalars['Boolean']['output']>;
  trainerRate?: Maybe<Scalars['Int']['output']>;
  trainerRating?: Maybe<Scalars['Float']['output']>;
  trainingType?: Maybe<TrainingType>;
  trainingTypeId?: Maybe<Scalars['ID']['output']>;
  unpaidSessions?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  videoAudioQuality?: Maybe<Scalars['String']['output']>;
};


export type SessionAssesmentArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
};


export type SessionLastTrainerDtlsArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
};


export type SessionTotalPaidAmountArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type SessionReport = {
  __typename?: 'SessionReport';
  _id?: Maybe<Scalars['ID']['output']>;
  canceledSessions?: Maybe<Scalars['Int']['output']>;
  completedSessions?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  noShowSessions?: Maybe<Scalars['Int']['output']>;
  scheduledSessions?: Maybe<Scalars['Int']['output']>;
  totalSessions?: Maybe<Scalars['Int']['output']>;
  userDetails?: Maybe<User>;
};

export enum SessionStatus {
  Cancelled = 'Cancelled',
  Completed = 'Completed',
  Noshow = 'Noshow',
  Open = 'Open',
  Reassign = 'Reassign',
  Scheduled = 'Scheduled'
}

export type SetupIntentRes = {
  __typename?: 'SetupIntentRes';
  setupIntentSecret: Scalars['String']['output'];
  stripeCustomerId: Scalars['String']['output'];
};

export enum SlotAvailablity {
  No = 'NO',
  Partial = 'PARTIAL',
  Yes = 'YES'
}

export type SocialMediaLink = {
  __typename?: 'SocialMediaLink';
  platform?: Maybe<SocialMediaPlatform>;
  url?: Maybe<Scalars['String']['output']>;
};

export type SocialMediaLinkInput = {
  platform?: InputMaybe<SocialMediaPlatform>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export enum SocialMediaPlatform {
  Facebook = 'FACEBOOK',
  Instagram = 'INSTAGRAM',
  Other = 'OTHER',
  Twitter = 'TWITTER',
  Youtube = 'YOUTUBE'
}

export type Specialization = {
  __typename?: 'Specialization';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  icon: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  status?: Maybe<Scalars['Boolean']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type Sports = {
  __typename?: 'Sports';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  sportName?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type StripeSubscription = {
  __typename?: 'StripeSubscription';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  paymentStatus: PaymentStatus;
  planId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['ID']['output'];
};

export type TimeSlot = {
  __typename?: 'TimeSlot';
  _id: Scalars['ID']['output'];
  assignedTo?: Maybe<User>;
  assignedToId?: Maybe<Scalars['ID']['output']>;
  endTime: Scalars['DateTime']['output'];
  session?: Maybe<Session>;
  sessionId?: Maybe<Scalars['ID']['output']>;
  startTime: Scalars['DateTime']['output'];
};

export type TimeSlotInput = {
  assignedToId?: InputMaybe<Scalars['ID']['input']>;
  endTime: Scalars['DateTime']['input'];
  sessionId?: InputMaybe<Scalars['ID']['input']>;
  startTime: Scalars['DateTime']['input'];
};

export type TokenRes = {
  __typename?: 'TokenRes';
  token?: Maybe<Scalars['String']['output']>;
};

export type TrainerOffDay = {
  __typename?: 'TrainerOffDay';
  _id: Scalars['ID']['output'];
  actionOwnerId?: Maybe<Scalars['ID']['output']>;
  actionTakenDateTime?: Maybe<Scalars['DateTime']['output']>;
  approvalStatus: Approval_Status;
  createdAt: Scalars['DateTime']['output'];
  offDayEndDateTime: Scalars['DateTime']['output'];
  offDayStartDateTime: Scalars['DateTime']['output'];
  trainerId: Scalars['ID']['output'];
  trainerIdUser?: Maybe<User>;
  updatedAt: Scalars['DateTime']['output'];
};

export type TrainerReccurringShift = {
  __typename?: 'TrainerReccurringShift';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdById: Scalars['ID']['output'];
  slots: Array<DaySlot>;
  trainerId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedById?: Maybe<Scalars['ID']['output']>;
};

export type TrainerShift = {
  __typename?: 'TrainerShift';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdById: Scalars['ID']['output'];
  shiftDate: Scalars['DateTime']['output'];
  shiftDayEndDate?: Maybe<Scalars['DateTime']['output']>;
  shiftDayStartDate?: Maybe<Scalars['DateTime']['output']>;
  timeSlots: Array<TimeSlot>;
  trainerId: Scalars['ID']['output'];
  trainerIdUser?: Maybe<User>;
  updatedAt: Scalars['DateTime']['output'];
  updatedById?: Maybe<Scalars['ID']['output']>;
};

export type Trainerpayment = {
  __typename?: 'Trainerpayment';
  _id: Scalars['ID']['output'];
  amount?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  paidOn?: Maybe<Scalars['DateTime']['output']>;
  programDetails?: Maybe<Program>;
  sessionCount?: Maybe<Scalars['Int']['output']>;
  sessionEndTime?: Maybe<Scalars['DateTime']['output']>;
  sessionId?: Maybe<Scalars['ID']['output']>;
  sessionStartTime?: Maybe<Scalars['DateTime']['output']>;
  sessionTimeZone?: Maybe<Scalars['String']['output']>;
  sessionUniqId?: Maybe<Scalars['String']['output']>;
  sportsDetails?: Maybe<Sports>;
  status?: Maybe<Scalars['String']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
  traineeIdUser?: Maybe<User>;
  traineeName?: Maybe<Scalars['String']['output']>;
  trainerId?: Maybe<Scalars['ID']['output']>;
  trainerIdUser?: Maybe<User>;
  trainerName?: Maybe<Scalars['String']['output']>;
  trainingType?: Maybe<TrainingType>;
  trainingTypeId?: Maybe<Scalars['ID']['output']>;
  transactionId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type TrainingType = {
  __typename?: 'TrainingType';
  _id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  order: Scalars['Int']['output'];
  status: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type TrianerTotalTrainingSessions = {
  __typename?: 'TrianerTotalTrainingSessions';
  date: Scalars['String']['output'];
  sessionCount: Scalars['Int']['output'];
  shiftDate?: Maybe<Scalars['DateTime']['output']>;
  totalSlots: Scalars['Int']['output'];
  trainerId: Scalars['ID']['output'];
  trainerIdUser?: Maybe<User>;
};

export type UpdateAppConfigInput = {
  _id: Scalars['ID']['input'];
  config?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAssessmentInput = {
  _id: Scalars['ID']['input'];
  assessment?: InputMaybe<Scalars['JSON']['input']>;
  sessionId?: InputMaybe<Scalars['ID']['input']>;
  traineeId?: InputMaybe<Scalars['ID']['input']>;
  trainerId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateCertificateInput = {
  _id: Scalars['ID']['input'];
  status?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDeviceTokenInput = {
  deviceId: Scalars['String']['input'];
  deviceToken: Scalars['String']['input'];
  deviceType: DeviceType;
};

export type UpdateMediaInput = {
  _id: Scalars['ID']['input'];
  createdById?: InputMaybe<Scalars['ID']['input']>;
  path?: InputMaybe<MediaType>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  thumbnail?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateNotificationInput = {
  _id: Scalars['ID']['input'];
  eventData?: InputMaybe<Scalars['String']['input']>;
  eventType?: InputMaybe<Scalars['String']['input']>;
  isRead?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  redirectPath?: InputMaybe<Scalars['String']['input']>;
  sendFromId?: InputMaybe<Scalars['ID']['input']>;
  sendToId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdatePlanInput = {
  _id: Scalars['ID']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  originalPrice?: InputMaybe<Scalars['Float']['input']>;
  planName?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  product_id?: InputMaybe<Scalars['String']['input']>;
  programId?: InputMaybe<Scalars['ID']['input']>;
  recommendedNoOfDays?: InputMaybe<Scalars['Int']['input']>;
  sessionCount?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateProgramInput = {
  _id: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  programName?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdatePurchaseInput = {
  _id: Scalars['ID']['input'];
  amount?: InputMaybe<Scalars['Float']['input']>;
  packageName?: InputMaybe<Scalars['String']['input']>;
  paymentDate?: InputMaybe<Scalars['DateTime']['input']>;
  paymentMethod?: InputMaybe<MethodOfPayment>;
  paymentMode?: InputMaybe<Scalars['String']['input']>;
  programId?: InputMaybe<Scalars['ID']['input']>;
  programName?: InputMaybe<Scalars['String']['input']>;
  sessionCount?: InputMaybe<Scalars['Int']['input']>;
  traineeId?: InputMaybe<Scalars['ID']['input']>;
  traineeName?: InputMaybe<Scalars['String']['input']>;
  transactionId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSessionInput = {
  _id: Scalars['ID']['input'];
  appUserFriendliness?: InputMaybe<Scalars['String']['input']>;
  clientFeedback?: InputMaybe<Scalars['String']['input']>;
  clientPerformance?: InputMaybe<Scalars['String']['input']>;
  continuationLikelihood?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  exercisePerformed?: InputMaybe<Scalars['String']['input']>;
  futureSessionImprovement?: InputMaybe<Scalars['String']['input']>;
  isFreeSession?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  programId?: InputMaybe<Scalars['ID']['input']>;
  programName?: InputMaybe<Scalars['String']['input']>;
  roomId?: InputMaybe<Scalars['String']['input']>;
  schedulingConvenience?: InputMaybe<Scalars['String']['input']>;
  sessionEndTime?: InputMaybe<Scalars['DateTime']['input']>;
  sessionExpectationMet?: InputMaybe<Scalars['String']['input']>;
  sessionLikes?: InputMaybe<Scalars['String']['input']>;
  sessionStartTime?: InputMaybe<Scalars['DateTime']['input']>;
  sessionStatus?: InputMaybe<SessionStatus>;
  specializationId?: InputMaybe<Scalars['ID']['input']>;
  sportId?: InputMaybe<Scalars['ID']['input']>;
  sportName?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  subscriptionId?: InputMaybe<Scalars['ID']['input']>;
  subscriptionType?: InputMaybe<Scalars['String']['input']>;
  targetedMuscle?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  technicalIssuesDescription?: InputMaybe<Scalars['String']['input']>;
  technicalIssuesEncountered?: InputMaybe<Scalars['Boolean']['input']>;
  timeZone?: InputMaybe<Scalars['TimeZone']['input']>;
  traineeId?: InputMaybe<Scalars['ID']['input']>;
  traineeRating?: InputMaybe<Scalars['Int']['input']>;
  trainerAssignedDateTime?: InputMaybe<Scalars['DateTime']['input']>;
  trainerCommunicationEffectiveness?: InputMaybe<Scalars['String']['input']>;
  trainerExpertiseRating?: InputMaybe<Scalars['String']['input']>;
  trainerFeedback?: InputMaybe<Scalars['String']['input']>;
  trainerId?: InputMaybe<Scalars['String']['input']>;
  trainerPaymentStatus?: InputMaybe<Scalars['Boolean']['input']>;
  trainerRating?: InputMaybe<Scalars['Float']['input']>;
  trainingTypeId?: InputMaybe<Scalars['ID']['input']>;
  videoAudioQuality?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSpecializationInput = {
  _id: Scalars['ID']['input'];
  icon: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSportsInput = {
  _id: Scalars['ID']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  sportName?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateStripeSubscriptionInput = {
  _id: Scalars['ID']['input'];
  paymentStatus?: InputMaybe<PaymentStatus>;
};

export type UpdateTrainerOffDayInput = {
  _id: Scalars['ID']['input'];
  actionOwnerId?: InputMaybe<Scalars['ID']['input']>;
  actionTakenDateTime?: InputMaybe<Scalars['DateTime']['input']>;
  approvalStatus?: InputMaybe<Approval_Status>;
  offDayEndDateTime?: InputMaybe<Scalars['DateTime']['input']>;
  offDayStartDateTime?: InputMaybe<Scalars['DateTime']['input']>;
  trainerId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateTrainerReccurringShiftInput = {
  _id: Scalars['ID']['input'];
  slots?: InputMaybe<Array<InputMaybe<DaySlotInput>>>;
  trainerId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateTrainerShiftInput = {
  _id: Scalars['ID']['input'];
  timeSlots: Array<TimeSlotInput>;
};

export type UpdateTrainerpaymentInput = {
  _id: Scalars['ID']['input'];
  amount?: InputMaybe<Scalars['Float']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  paidOn?: InputMaybe<Scalars['DateTime']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  trainerId?: InputMaybe<Scalars['ID']['input']>;
  trainerName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTrainingTypeInput = {
  _id: Scalars['ID']['input'];
  icon?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserCertificateInput = {
  _id: Scalars['ID']['input'];
  certificateId?: InputMaybe<Scalars['ID']['input']>;
  filePath?: InputMaybe<Scalars['String']['input']>;
  fileType?: InputMaybe<UserCertificateType>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateUserInput = {
  _id: Scalars['ID']['input'];
  about?: InputMaybe<Scalars['String']['input']>;
  ageRange?: InputMaybe<AgeRange>;
  country?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  createdById?: InputMaybe<Scalars['ID']['input']>;
  currentEngagements?: InputMaybe<EngagementTypeInput>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  deleteAccountToken?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  emgContactCountryCode?: InputMaybe<Scalars['String']['input']>;
  emgContactFirstName?: InputMaybe<Scalars['String']['input']>;
  emgContactLastName?: InputMaybe<Scalars['String']['input']>;
  emgContactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  emgContactRelation?: InputMaybe<Scalars['String']['input']>;
  equipments?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fitCurveBalance?: InputMaybe<Scalars['Int']['input']>;
  fitPrimeBalance?: InputMaybe<Scalars['Int']['input']>;
  fitVarsityBalance?: InputMaybe<Scalars['Int']['input']>;
  fitnessGoals?: InputMaybe<Scalars['String']['input']>;
  freeSessionBalance?: InputMaybe<Scalars['Int']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  heardAboutUs?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  heightType?: InputMaybe<HeightType>;
  injury?: InputMaybe<EngagementTypeInput>;
  languages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastLoggedIn?: InputMaybe<Scalars['DateTime']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lastPositionSelected?: InputMaybe<Scalars['String']['input']>;
  lastProgramSelected?: InputMaybe<Scalars['String']['input']>;
  lastSportSelected?: InputMaybe<Scalars['String']['input']>;
  locationName?: InputMaybe<Scalars['String']['input']>;
  locationPoint?: InputMaybe<LocationPointInput>;
  loginTryCount?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumberWithCountryCode?: InputMaybe<Scalars['String']['input']>;
  preferredWorkouts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preferredWorkoutsIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  profileImage?: InputMaybe<Scalars['String']['input']>;
  programs?: InputMaybe<Array<InputMaybe<ProgramDtlsInput>>>;
  rate?: InputMaybe<Scalars['Int']['input']>;
  referralCode?: InputMaybe<Scalars['String']['input']>;
  resetPasswordToken?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  sessionBalance?: InputMaybe<Scalars['Int']['input']>;
  socialMediaLinks?: InputMaybe<Array<InputMaybe<SocialMediaLinkInput>>>;
  specializationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  timezone?: InputMaybe<Scalars['TimeZone']['input']>;
  timezoneCode?: InputMaybe<Scalars['String']['input']>;
  traineeAgeConsent?: InputMaybe<Scalars['Boolean']['input']>;
  trainerSelectedProgramIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  weight?: InputMaybe<Scalars['Float']['input']>;
  weightType?: InputMaybe<WeightType>;
  workoutPreference?: InputMaybe<Scalars['String']['input']>;
};

export type User = {
  __typename?: 'User';
  _id: Scalars['ID']['output'];
  about?: Maybe<Scalars['String']['output']>;
  ageRange?: Maybe<AgeRange>;
  archived?: Maybe<Scalars['Boolean']['output']>;
  averageRating?: Maybe<Scalars['Float']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdById?: Maybe<Scalars['ID']['output']>;
  currentEngagements?: Maybe<EngagementType>;
  dateOfBirth?: Maybe<Scalars['DateTime']['output']>;
  deleteAccountToken?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['EmailAddress']['output']>;
  emgContactCountryCode?: Maybe<Scalars['String']['output']>;
  emgContactFirstName?: Maybe<Scalars['String']['output']>;
  emgContactFullName?: Maybe<Scalars['String']['output']>;
  emgContactLastName?: Maybe<Scalars['String']['output']>;
  emgContactPhoneNumber?: Maybe<Scalars['String']['output']>;
  emgContactRelation?: Maybe<Scalars['String']['output']>;
  emgPhoneNumberWithCountryCode?: Maybe<Scalars['String']['output']>;
  equipments?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  firstName?: Maybe<Scalars['String']['output']>;
  fitCurveBalance?: Maybe<Scalars['Int']['output']>;
  fitPrimeBalance?: Maybe<Scalars['Int']['output']>;
  fitVarsityBalance?: Maybe<Scalars['Int']['output']>;
  fitnessGoals?: Maybe<Scalars['String']['output']>;
  freeSessionBalance?: Maybe<Scalars['Int']['output']>;
  gender?: Maybe<Gender>;
  heardAboutUs?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  heightType?: Maybe<HeightType>;
  injury?: Maybe<EngagementType>;
  languages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  lastLoggedIn?: Maybe<Scalars['DateTime']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  lastPurchase?: Maybe<Scalars['DateTime']['output']>;
  latestAssessment?: Maybe<Assessment>;
  locationName?: Maybe<Scalars['String']['output']>;
  locationPoint?: Maybe<Location>;
  loginTryCount?: Maybe<Scalars['Int']['output']>;
  medias?: Maybe<Array<Maybe<Media>>>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  phoneNumberWithCountryCode?: Maybe<Scalars['String']['output']>;
  preferredWorkouts?: Maybe<Array<Maybe<TrainingType>>>;
  preferredWorkoutsIds?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  profileImage?: Maybe<Scalars['String']['output']>;
  profileImageUrlPath?: Maybe<Scalars['String']['output']>;
  programs?: Maybe<Array<Maybe<ProgramDtls>>>;
  rate?: Maybe<Scalars['Int']['output']>;
  referralCode?: Maybe<Scalars['String']['output']>;
  resetPasswordToken?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Role>;
  sessionAssigned?: Maybe<Scalars['Int']['output']>;
  sessionBalance?: Maybe<Scalars['Int']['output']>;
  sessionCompleted?: Maybe<Scalars['Int']['output']>;
  sessionDtls?: Maybe<Session>;
  sessionScheduled?: Maybe<Scalars['Int']['output']>;
  slotAvailablity?: Maybe<SlotAvailablity>;
  socialMediaLinks?: Maybe<Array<Maybe<SocialMediaLink>>>;
  specializationIds?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  specializations?: Maybe<Array<Maybe<Specialization>>>;
  status?: Maybe<Scalars['Boolean']['output']>;
  subscription?: Maybe<Array<Maybe<Purchase>>>;
  timezone?: Maybe<Scalars['TimeZone']['output']>;
  timezoneCode?: Maybe<Scalars['String']['output']>;
  traineeAgeConsent?: Maybe<Scalars['Boolean']['output']>;
  traineeLastPositionSelected?: Maybe<Scalars['String']['output']>;
  traineeLastProgramSelected?: Maybe<Program>;
  traineeLastProgramSelectedId?: Maybe<Scalars['ID']['output']>;
  traineeLastSportSelected?: Maybe<Sports>;
  traineeLastSportSelectedId?: Maybe<Scalars['ID']['output']>;
  trainerSelectedProgramDtls?: Maybe<Array<Maybe<ProgramDtls>>>;
  trainerSelectedProgramIds?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  trainerTotalSessions?: Maybe<Scalars['Int']['output']>;
  upcomingSessionDate?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  userCertificateCount: Scalars['Int']['output'];
  userCertificates?: Maybe<Array<UserCertificate>>;
  weight?: Maybe<Scalars['Float']['output']>;
  weightType?: Maybe<WeightType>;
  workoutPreference?: Maybe<Scalars['String']['output']>;
};


export type UserLastPurchaseArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
};


export type UserLatestAssessmentArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
};


export type UserMediasArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
};


export type UserProfileImageArgs = {
  formats?: InputMaybe<Scalars['JSON']['input']>;
};


export type UserSessionAssignedArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
};


export type UserSessionCompletedArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
};


export type UserSessionDtlsArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
};


export type UserSessionScheduledArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
};


export type UserTrainerTotalSessionsArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
};


export type UserUserCertificateCountArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type UserUserCertificatesArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
};

export type UserCertificate = {
  __typename?: 'UserCertificate';
  _id: Scalars['ID']['output'];
  certificate?: Maybe<Certificate>;
  certificateId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  filePath?: Maybe<Scalars['String']['output']>;
  filePathUrl?: Maybe<Scalars['String']['output']>;
  fileType: Scalars['String']['output'];
  status?: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  userId: Scalars['ID']['output'];
};


export type UserCertificateFilePathArgs = {
  formats?: InputMaybe<Scalars['JSON']['input']>;
};

export enum UserCertificateType {
  Document = 'DOCUMENT',
  Image = 'IMAGE',
  Video = 'VIDEO'
}

export type UserLog = {
  __typename?: 'UserLog';
  logOut?: Maybe<Scalars['DateTime']['output']>;
  login?: Maybe<Scalars['DateTime']['output']>;
};

export enum WeightType {
  Kilogram = 'KILOGRAM',
  Pound = 'POUND'
}

export enum WorkoutFrequency {
  EveryDay = 'EVERY_DAY',
  FourTimesPerWeek = 'FOUR_TIMES_PER_WEEK',
  OccassinallyWhenIHaveTime = 'OCCASSINALLY_WHEN_I_HAVE_TIME',
  OncePerWeek = 'ONCE_PER_WEEK',
  OnlyOnWeekends = 'ONLY_ON_WEEKENDS',
  ThreeTimesPerWeek = 'THREE_TIMES_PER_WEEK',
  TwicePerWeek = 'TWICE_PER_WEEK'
}

export type FieldsDtls = {
  __typename?: 'fieldsDtls';
  position?: Maybe<Scalars['DateTime']['output']>;
  sport?: Maybe<Scalars['String']['output']>;
};

export type FieldsDtlsInput = {
  position?: InputMaybe<Scalars['DateTime']['input']>;
  sport?: InputMaybe<Scalars['String']['input']>;
};

export enum MethodOfPayment {
  Complimentary = 'COMPLIMENTARY',
  Inapp = 'INAPP',
  Other = 'OTHER',
  Stripe = 'STRIPE',
  WelcomeReward = 'WELCOME_REWARD'
}

export type RateLimitInput = {
  max: Scalars['Int']['input'];
  window: Scalars['String']['input'];
};

export type Receipt = {
  __typename?: 'receipt';
  amount?: Maybe<Scalars['Float']['output']>;
  currencyType?: Maybe<Scalars['String']['output']>;
  paymentDate?: Maybe<Scalars['DateTime']['output']>;
  sessionCount?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  transactionId?: Maybe<Scalars['String']['output']>;
};

export type SubscriptionHeader = {
  __typename?: 'subscriptionHeader';
  revenueEarned?: Maybe<Scalars['Float']['output']>;
  sessionSubscribed?: Maybe<Scalars['Int']['output']>;
  totalPurchases?: Maybe<Scalars['Int']['output']>;
};

export type TrainerCapacityRpt = {
  __typename?: 'trainerCapacityRpt';
  totalAssignedSlots?: Maybe<Scalars['Int']['output']>;
  totalUnassignedSlots?: Maybe<Scalars['Int']['output']>;
  trainerDetails?: Maybe<User>;
  trainerId?: Maybe<Scalars['ID']['output']>;
};

export type TrainerPaymentHistory = {
  __typename?: 'trainerPaymentHistory';
  _id: Scalars['String']['output'];
  amount?: Maybe<Scalars['Float']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  paidOn?: Maybe<Scalars['DateTime']['output']>;
  programDetails?: Maybe<Program>;
  programId?: Maybe<Scalars['ID']['output']>;
  sessionCount?: Maybe<Scalars['Int']['output']>;
  sessionEndTime?: Maybe<Scalars['DateTime']['output']>;
  sessionStartTime?: Maybe<Scalars['DateTime']['output']>;
  sessionTimeZone?: Maybe<Scalars['String']['output']>;
  sessionUniqId?: Maybe<Scalars['String']['output']>;
  sportId?: Maybe<Scalars['ID']['output']>;
  sportsDetails?: Maybe<Sports>;
  status?: Maybe<Scalars['String']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
  traineeName?: Maybe<Scalars['String']['output']>;
  trainerId?: Maybe<Scalars['ID']['output']>;
  trainerName?: Maybe<Scalars['String']['output']>;
  trainingType?: Maybe<TrainingType>;
  trainingTypeId?: Maybe<Scalars['ID']['output']>;
  transactionId: Scalars['String']['output'];
};

export type VerifyReceiptInput = {
  amount: Scalars['Float']['input'];
  appType: Scalars['String']['input'];
  currencyType?: InputMaybe<Scalars['String']['input']>;
  localizedPrice?: InputMaybe<Scalars['String']['input']>;
  packageName?: InputMaybe<Scalars['String']['input']>;
  productId: Scalars['String']['input'];
  programId?: InputMaybe<Scalars['ID']['input']>;
  programName?: InputMaybe<Scalars['String']['input']>;
  purchaseToken?: InputMaybe<Scalars['String']['input']>;
  receiptData?: InputMaybe<Scalars['String']['input']>;
  transactionId?: InputMaybe<Scalars['String']['input']>;
};

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', logout: { __typename?: 'ResponsePayload', message: string, status: number } };

export type GenerateOtpMutationVariables = Exact<{
  countryCode: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
}>;


export type GenerateOtpMutation = { __typename?: 'Mutation', generateOtp: { __typename?: 'ResponsePayload', message: string, status: number } };

export type VerifyOtpMutationVariables = Exact<{
  countryCode: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  otp: Scalars['String']['input'];
}>;


export type VerifyOtpMutation = { __typename?: 'Mutation', verifyOtp: { __typename?: 'Login', accessToken: string, refreshToken: string } };

export type UpdateUserMutationVariables = Exact<{
  data: UpdateUserInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', _id: string } };

export type ReadOneNotificationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ReadOneNotificationMutation = { __typename?: 'Mutation', readOneNotification: { __typename?: 'ResponsePayload', message: string, status: number } };

export type DeleteManyNotificationMutationVariables = Exact<{
  filter: Scalars['JSON']['input'];
}>;


export type DeleteManyNotificationMutation = { __typename?: 'Mutation', deleteManyNotification: Array<{ __typename?: 'Notification', _id: string }> };

export type UpdateDeviceTokenMutationVariables = Exact<{
  data: UpdateDeviceTokenInput;
}>;


export type UpdateDeviceTokenMutation = { __typename?: 'Mutation', updateDeviceToken: { __typename?: 'DeviceToken', _id: string } };

export type GetCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserQuery = { __typename?: 'Query', getCurrentUser?: { __typename?: 'User', _id: string, displayName?: string | null, email?: any | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, profileImage?: string | null, sessionBalance?: number | null, freeSessionBalance?: number | null, fitCurveBalance?: number | null, fitPrimeBalance?: number | null, fitVarsityBalance?: number | null, role?: Role | null, status?: boolean | null } | null };

export type MeetOurTrainersQueryVariables = Exact<{ [key: string]: never; }>;


export type MeetOurTrainersQuery = { __typename?: 'Query', meetOurTrainers: Array<{ __typename?: 'User', _id: string, firstName?: string | null, lastName?: string | null, dateOfBirth?: any | null, displayName?: string | null, profileImage?: string | null, gender?: Gender | null, lazyLoadingAlt?: string | null } | null> };

export type GetAllTrainersQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<Scalars['JSON']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type GetAllTrainersQuery = { __typename?: 'Query', getAllTrainersCount: number, getAllTrainers: Array<{ __typename?: 'User', _id: string, gender?: Gender | null, lastName?: string | null, firstName?: string | null, displayName?: string | null, profileImage?: string | null, averageRating?: number | null } | null> };

export type GetAllSpecializationQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type GetAllSpecializationQuery = { __typename?: 'Query', getAllSpecialization: Array<{ __typename?: 'Specialization', _id: string, title: string } | null> };

export type GetSignedUrlQueryVariables = Exact<{
  fileName: Scalars['String']['input'];
  fileType: FileType;
}>;


export type GetSignedUrlQuery = { __typename?: 'Query', getSignedUrl: { __typename?: 'S3UrlPayload', key: string, url: string } };

export type GetAllTrainingTypeQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type GetAllTrainingTypeQuery = { __typename?: 'Query', getAllTrainingType: Array<{ __typename?: 'TrainingType', _id: string, order: number, title: string, icon?: string | null } | null> };

export type GetUserByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetUserByIdQuery = { __typename?: 'Query', getUserById?: { __typename?: 'User', _id: string, email?: any | null, ageRange?: AgeRange | null, countryCode?: string | null, firstName?: string | null, lastName?: string | null, displayName?: string | null, profileImage?: string | null, phoneNumber?: string | null, fitPrimeBalance?: number | null, fitCurveBalance?: number | null, fitVarsityBalance?: number | null, freeSessionBalance?: number | null, dateOfBirth?: any | null, timezone?: any | null, gender?: Gender | null, height?: number | null, weight?: number | null, heightType?: HeightType | null, weightType?: WeightType | null, locationName?: string | null, languages?: Array<string | null> | null, fitnessGoals?: string | null, equipments?: Array<string | null> | null, workoutPreference?: string | null, heardAboutUs?: string | null, about?: string | null, averageRating?: number | null, userCertificateCount: number, injury?: { __typename?: 'EngagementType', description?: string | null, status?: boolean | null } | null, preferredWorkouts?: Array<{ __typename?: 'TrainingType', _id: string, title: string } | null> | null, currentEngagements?: { __typename?: 'EngagementType', description?: string | null, status?: boolean | null } | null, specializations?: Array<{ __typename?: 'Specialization', _id: string, title: string } | null> | null, medias?: Array<{ __typename?: 'Media', _id: string, path?: string | null, type: string, thumbnail?: string | null } | null> | null, socialMediaLinks?: Array<{ __typename?: 'SocialMediaLink', url?: string | null, platform?: SocialMediaPlatform | null } | null> | null, userCertificates?: Array<{ __typename?: 'UserCertificate', _id: string, filePath?: string | null, filePathUrl?: string | null, certificate?: { __typename?: 'Certificate', _id: string, title: string } | null }> | null } | null };

export type GetAllNotificationQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
  filter?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type GetAllNotificationQuery = { __typename?: 'Query', getAllNotification: Array<{ __typename?: 'Notification', _id: string, createdAt: any, eventData?: string | null, eventType: string, isRead?: boolean | null, message: string, redirectPath?: string | null, sendFromId: string, title: string, sendFromIdUser?: { __typename?: 'User', _id: string, displayName?: string | null, profileImage?: string | null } | null } | null> };

export type GetAllNotificationCountQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type GetAllNotificationCountQuery = { __typename?: 'Query', getAllNotificationCount: number };

export type GetAllProgramQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['JSON']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAllProgramQuery = { __typename?: 'Query', getAllProgram: Array<{ __typename?: 'Program', _id: string, programName: string, description?: string | null, status?: boolean | null, createdAt: any } | null> };

export type GetAllSportsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['JSON']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAllSportsQuery = { __typename?: 'Query', getAllSports: Array<{ __typename?: 'Sports', _id: string, status?: boolean | null, sportName?: string | null, order?: number | null, updatedAt: any, createdAt: any } | null> };

export type CreateZoomTokenMutationVariables = Exact<{
  data: CreateZoomToken;
}>;


export type CreateZoomTokenMutation = { __typename?: 'Mutation', createZoomToken: { __typename?: 'CreateZoomTokenOutPut', status: boolean, token: string } };

export type CreateAssessmentMutationVariables = Exact<{
  data: CreateAssessmentInput;
}>;


export type CreateAssessmentMutation = { __typename?: 'Mutation', createAssessment: { __typename?: 'Assessment', _id: string, assessment?: any | null } };

export type GetLogInfoQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetLogInfoQuery = { __typename?: 'Query', getLogInfo?: { __typename?: 'LogInfo', status?: boolean | null } | null };

export type GetAllAssessmentQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type GetAllAssessmentQuery = { __typename?: 'Query', getAllAssessment: Array<{ __typename?: 'Assessment', _id: string, assessment?: any | null, createdAt: any, createdById?: string | null, sessionId: string, traineeId: string, trainerId: string } | null> };

export type TrainerPaymentHistoryQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['JSON']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  trainerPaymentHistoryCountSearch2?: InputMaybe<Scalars['String']['input']>;
  trainerPaymentHistoryCountFilter2?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type TrainerPaymentHistoryQuery = { __typename?: 'Query', trainerPaymentHistoryCount: number, trainerPaymentHistory: Array<{ __typename?: 'trainerPaymentHistory', _id: string, amount?: number | null, paidOn?: any | null, note?: string | null, sessionCount?: number | null, traineeName?: string | null, trainerName?: string | null, transactionId: string, trainerId?: string | null, trainingTypeId?: string | null, sessionUniqId?: string | null, trainingType?: { __typename?: 'TrainingType', _id: string, title: string, icon?: string | null } | null } | null> };

export type GetAllTrainerpaymentQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['JSON']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  getAllTrainerpaymentCountSearch2?: InputMaybe<Scalars['String']['input']>;
  getAllTrainerpaymentCountFilter2?: InputMaybe<Scalars['JSON']['input']>;
  formats?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type GetAllTrainerpaymentQuery = { __typename?: 'Query', getAllTrainerpaymentCount: number, getAllTrainerpayment: Array<{ __typename?: 'Trainerpayment', _id: string, createdAt?: any | null, updatedAt?: any | null, amount?: number | null, trainerId?: string | null, note?: string | null, paidOn?: any | null, trainerName?: string | null, sessionStartTime?: any | null, sessionEndTime?: any | null, sessionTimeZone?: string | null, timeZone?: string | null, traineeName?: string | null, trainingTypeId?: string | null, sessionUniqId?: string | null, sessionId?: string | null, transactionId: string, status?: string | null, sessionCount?: number | null, programDetails?: { __typename?: 'Program', programName: string } | null, trainingType?: { __typename?: 'TrainingType', _id: string, title: string } | null, traineeIdUser?: { __typename?: 'User', _id: string, firstName?: string | null, lastName?: string | null, profileImage?: string | null } | null, trainerIdUser?: { __typename?: 'User', _id: string, firstName?: string | null, lastName?: string | null } | null } | null> };

export type DeleteUserMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
}>;


export type DeleteUserMutation = { __typename?: 'Mutation', deleteUser: { __typename?: 'User', _id: string } };

export type GetSessionByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetSessionByIdQuery = { __typename?: 'Query', getSessionById?: { __typename?: 'Session', _id: string, sessionStartTime: any, sessionEndTime: any, sessionStatus: SessionStatus, programId?: string | null, sportId?: string | null, position?: string | null, sessionUniqId?: string | null, status?: boolean | null, trainerId?: string | null, trainerExpertiseRating?: string | null, traineeId: string, traineeRating?: number | null, timeZone: any, programDetails?: { __typename?: 'Program', programName: string } | null, assesment?: { __typename: 'Assessment', _id: string, createdAt: any, updatedAt: any, traineeId: string, trainerId: string, sessionId: string, assessment?: any | null } | null, trainingType?: { __typename?: 'TrainingType', _id: string, title: string, icon?: string | null } | null, trainerIdUser?: { __typename?: 'User', _id: string, about?: string | null, averageRating?: number | null, dateOfBirth?: any | null, firstName?: string | null, lastName?: string | null, profileImage?: string | null, specializations?: Array<{ __typename?: 'Specialization', _id: string, title: string } | null> | null, medias?: Array<{ __typename?: 'Media', _id: string, path?: string | null, type: string } | null> | null } | null, traineeIdUser?: { __typename?: 'User', _id: string, ageRange?: AgeRange | null, firstName?: string | null, lastName?: string | null, displayName?: string | null, dateOfBirth?: any | null, height?: number | null, weight?: number | null, profileImage?: string | null, gender?: Gender | null, weightType?: WeightType | null, heightType?: HeightType | null, fitnessGoals?: string | null, equipments?: Array<string | null> | null, workoutPreference?: string | null, injury?: { __typename?: 'EngagementType', status?: boolean | null, description?: string | null } | null, preferredWorkouts?: Array<{ __typename?: 'TrainingType', _id: string, title: string } | null> | null, currentEngagements?: { __typename?: 'EngagementType', status?: boolean | null, description?: string | null } | null } | null } | null };

export type GetOverAllAssessmentQueryVariables = Exact<{
  traineeId: Scalars['ID']['input'];
}>;


export type GetOverAllAssessmentQuery = { __typename?: 'Query', getOverAllAssessment?: any | null };

export type GetOneSessionQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['JSON']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type GetOneSessionQuery = { __typename?: 'Query', getOneSession?: { __typename?: 'Session', _id: string, sessionStartTime: any, sessionEndTime: any, clientPerformance?: string | null, targetedMuscle?: Array<string | null> | null, clientFeedback?: string | null, exercisePerformed?: string | null, programName?: string | null, programId?: string | null, lastTrainerDtls?: { __typename?: 'User', _id: string, displayName?: string | null, firstName?: string | null, lastName?: string | null, profileImage?: string | null } | null, assesment?: { __typename?: 'Assessment', _id: string, assessment?: any | null } | null, trainingType?: { __typename?: 'TrainingType', title: string } | null, trainerIdUser?: { __typename?: 'User', _id: string, profileImage?: string | null, displayName?: string | null, firstName?: string | null, lastName?: string | null } | null } | null };

export type GetNotesFromPreviosSessionsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['JSON']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  formats?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type GetNotesFromPreviosSessionsQuery = { __typename?: 'Query', getNotesFromPreviosSessions?: Array<{ __typename?: 'Session', clientFeedback?: string | null, _id: string, sessionStartTime: any, sessionEndTime: any, trainerIdUser?: { __typename?: 'User', _id: string, profileImage?: string | null, displayName?: string | null } | null } | null> | null };

export type CreateSessionMutationVariables = Exact<{
  data: CreateSessionInput;
}>;


export type CreateSessionMutation = { __typename?: 'Mutation', createSession: { __typename?: 'Session', _id: string } };

export type UpdateSessionMutationVariables = Exact<{
  data: UpdateSessionInput;
}>;


export type UpdateSessionMutation = { __typename?: 'Mutation', updateSession: { __typename?: 'Session', _id: string } };

export type GetAllSessionQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['JSON']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAllSessionQuery = { __typename?: 'Query', getAllSessionCount: number, getAllSession: Array<{ __typename?: 'Session', _id: string, duration?: number | null, roomId?: string | null, sessionStartTime: any, sessionEndTime: any, sessionStatus: SessionStatus, sportId?: string | null, programId?: string | null, programName?: string | null, position?: string | null, sessionUniqId?: string | null, status?: boolean | null, trainerAssignedDateTime?: any | null, timeZone: any, trainerId?: string | null, futureSessionImprovement?: string | null, targetedMuscle?: Array<string | null> | null, clientFeedback?: string | null, traineeId: string, updatedAt: any, subscriptionType: string, trainerExpertiseRating?: string | null, createdById?: string | null, createdAt: any, trainerFeedback?: string | null, clientPerformance?: string | null, exercisePerformed?: string | null, trainingType?: { __typename?: 'TrainingType', _id: string, icon?: string | null, title: string, status: boolean, order: number } | null, trainerIdUser?: { __typename?: 'User', _id: string, firstName?: string | null, lastName?: string | null, profileImage?: string | null } | null, lastTrainerDtls?: { __typename?: 'User', _id: string, displayName?: string | null, firstName?: string | null, lastName?: string | null, profileImage?: string | null } | null, assesment?: { __typename?: 'Assessment', _id: string, assessment?: any | null } | null, traineeIdUser?: { __typename?: 'User', _id: string, profileImage?: string | null, firstName?: string | null, lastName?: string | null, displayName?: string | null } | null, participantLogs?: { __typename?: 'ParticipantLogs', LogType?: LogType | null, participantId?: string | null, time?: any | null } | null } | null> };

export type GetAllTrainingTypeSessionListingQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['JSON']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAllTrainingTypeSessionListingQuery = { __typename?: 'Query', getAllTrainingType: Array<{ __typename?: 'TrainingType', _id: string, createdAt: any, updatedAt: any, title: string, icon?: string | null, order: number, status: boolean } | null> };

export type GetAllSessionsCountQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type GetAllSessionsCountQuery = { __typename?: 'Query', getAllSessionCount: number };

export type QueryQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type QueryQuery = { __typename?: 'Query', getAllTrainingTypeCount: number };

export type GetSessionBalanceQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSessionBalanceQuery = { __typename?: 'Query', getCurrentUser?: { __typename?: 'User', sessionBalance?: number | null, fitCurveBalance?: number | null, fitPrimeBalance?: number | null, fitVarsityBalance?: number | null, freeSessionBalance?: number | null, ageRange?: AgeRange | null } | null };

export type CardSetupIntentMutationVariables = Exact<{ [key: string]: never; }>;


export type CardSetupIntentMutation = { __typename?: 'Mutation', cardSetupIntent: { __typename?: 'SetupIntentRes', setupIntentSecret: string, stripeCustomerId: string } };

export type ProductPaymentIntentMutationVariables = Exact<{
  data: ProductPaymentIntentInput;
}>;


export type ProductPaymentIntentMutation = { __typename?: 'Mutation', productPaymentIntent: { __typename?: 'ProductPaymentIntentRes', paymentIntentSecret: string, stripeCustomerId: string, customerSessionSecret: string } };

export type GetAllPurchaseQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAllPurchaseQuery = { __typename?: 'Query', getAllPurchaseCount: number, getAllPurchase: Array<{ __typename?: 'Purchase', _id: string, paymentDate: any, transactionId?: string | null, sessionSubscribed?: number | null, paymentMethod?: MethodOfPayment | null, paymentMode?: string | null, amount: number, sessionCount: number, localizedPrice?: string | null, currencyType?: string | null, programDetails?: { __typename?: 'Program', programName: string } | null } | null> };

export type GetAllPlanQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['JSON']['input']>;
  sort?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type GetAllPlanQuery = { __typename?: 'Query', getAllPlan: Array<{ __typename?: 'Plan', recommendedNoOfDays: number, originalPrice?: number | null, price: number, sessionCount: number, planName: string, _id: string, product_id: string, program: { __typename?: 'Program', programName: string, description?: string | null } } | null> };

export type GetMySavedCardsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMySavedCardsQuery = { __typename?: 'Query', getMySavedCards: { __typename?: 'SavedCards', stripeCustomerId: string, cards?: Array<{ __typename?: 'Card', brand?: string | null, expMonth?: number | null, expYear?: number | null, last4?: string | null } | null> | null } };


export const LogoutDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Logout"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logout"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<LogoutMutation, LogoutMutationVariables>;
export const GenerateOtpDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GenerateOtp"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"countryCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phoneNumber"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generateOtp"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"countryCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"countryCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"phoneNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phoneNumber"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<GenerateOtpMutation, GenerateOtpMutationVariables>;
export const VerifyOtpDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"VerifyOtp"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"countryCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phoneNumber"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"otp"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"verifyOtp"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"countryCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"countryCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"phoneNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phoneNumber"}}},{"kind":"Argument","name":{"kind":"Name","value":"otp"},"value":{"kind":"Variable","name":{"kind":"Name","value":"otp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accessToken"}},{"kind":"Field","name":{"kind":"Name","value":"refreshToken"}}]}}]}}]} as unknown as DocumentNode<VerifyOtpMutation, VerifyOtpMutationVariables>;
export const UpdateUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateUserInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}}]}}]} as unknown as DocumentNode<UpdateUserMutation, UpdateUserMutationVariables>;
export const ReadOneNotificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ReadOneNotification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"readOneNotification"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<ReadOneNotificationMutation, ReadOneNotificationMutationVariables>;
export const DeleteManyNotificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteManyNotification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteManyNotification"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}}]}}]} as unknown as DocumentNode<DeleteManyNotificationMutation, DeleteManyNotificationMutationVariables>;
export const UpdateDeviceTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateDeviceToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateDeviceTokenInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateDeviceToken"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}}]}}]} as unknown as DocumentNode<UpdateDeviceTokenMutation, UpdateDeviceTokenMutationVariables>;
export const GetCurrentUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCurrentUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCurrentUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"profileImage"}},{"kind":"Field","name":{"kind":"Name","value":"sessionBalance"}},{"kind":"Field","name":{"kind":"Name","value":"freeSessionBalance"}},{"kind":"Field","name":{"kind":"Name","value":"fitCurveBalance"}},{"kind":"Field","name":{"kind":"Name","value":"fitPrimeBalance"}},{"kind":"Field","name":{"kind":"Name","value":"fitVarsityBalance"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<GetCurrentUserQuery, GetCurrentUserQueryVariables>;
export const MeetOurTrainersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MeetOurTrainers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meetOurTrainers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"profileImage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"formats"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"edits"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"resize"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"132"}},{"kind":"ObjectField","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"142"}},{"kind":"ObjectField","name":{"kind":"Name","value":"fit"},"value":{"kind":"StringValue","value":"cover","block":false}}]}}]}}]}}]},{"kind":"Field","alias":{"kind":"Name","value":"lazyLoadingAlt"},"name":{"kind":"Name","value":"profileImage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"formats"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"edits"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"resize"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"20"}},{"kind":"ObjectField","name":{"kind":"Name","value":"fit"},"value":{"kind":"StringValue","value":"contain","block":false}}]}}]}}]}}]},{"kind":"Field","name":{"kind":"Name","value":"gender"}}]}}]}}]} as unknown as DocumentNode<MeetOurTrainersQuery, MeetOurTrainersQueryVariables>;
export const GetAllTrainersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllTrainers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAllTrainers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"profileImage"}},{"kind":"Field","name":{"kind":"Name","value":"averageRating"}}]}},{"kind":"Field","name":{"kind":"Name","value":"getAllTrainersCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}]}]}}]} as unknown as DocumentNode<GetAllTrainersQuery, GetAllTrainersQueryVariables>;
export const GetAllSpecializationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllSpecialization"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAllSpecialization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]} as unknown as DocumentNode<GetAllSpecializationQuery, GetAllSpecializationQueryVariables>;
export const GetSignedUrlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSignedUrl"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FileType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getSignedUrl"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"fileName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileName"}}},{"kind":"Argument","name":{"kind":"Name","value":"fileType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<GetSignedUrlQuery, GetSignedUrlQueryVariables>;
export const GetAllTrainingTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllTrainingType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAllTrainingType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}}]}}]}}]} as unknown as DocumentNode<GetAllTrainingTypeQuery, GetAllTrainingTypeQueryVariables>;
export const GetUserByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getUserById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"ageRange"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"profileImage"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"fitPrimeBalance"}},{"kind":"Field","name":{"kind":"Name","value":"fitCurveBalance"}},{"kind":"Field","name":{"kind":"Name","value":"fitVarsityBalance"}},{"kind":"Field","name":{"kind":"Name","value":"freeSessionBalance"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"heightType"}},{"kind":"Field","name":{"kind":"Name","value":"weightType"}},{"kind":"Field","name":{"kind":"Name","value":"locationName"}},{"kind":"Field","name":{"kind":"Name","value":"languages"}},{"kind":"Field","name":{"kind":"Name","value":"fitnessGoals"}},{"kind":"Field","name":{"kind":"Name","value":"injury"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"preferredWorkouts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"equipments"}},{"kind":"Field","name":{"kind":"Name","value":"currentEngagements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workoutPreference"}},{"kind":"Field","name":{"kind":"Name","value":"heardAboutUs"}},{"kind":"Field","name":{"kind":"Name","value":"about"}},{"kind":"Field","name":{"kind":"Name","value":"averageRating"}},{"kind":"Field","name":{"kind":"Name","value":"specializations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"medias"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"}}]}},{"kind":"Field","name":{"kind":"Name","value":"socialMediaLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"platform"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userCertificateCount"}},{"kind":"Field","name":{"kind":"Name","value":"userCertificates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"filePath"}},{"kind":"Field","name":{"kind":"Name","value":"filePathUrl"}},{"kind":"Field","name":{"kind":"Name","value":"certificate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetUserByIdQuery, GetUserByIdQueryVariables>;
export const GetAllNotificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllNotification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAllNotification"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"eventData"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"isRead"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"redirectPath"}},{"kind":"Field","name":{"kind":"Name","value":"sendFromId"}},{"kind":"Field","name":{"kind":"Name","value":"sendFromIdUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"profileImage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]} as unknown as DocumentNode<GetAllNotificationQuery, GetAllNotificationQueryVariables>;
export const GetAllNotificationCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllNotificationCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAllNotificationCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}]}]}}]} as unknown as DocumentNode<GetAllNotificationCountQuery, GetAllNotificationCountQueryVariables>;
export const GetAllProgramDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllProgram"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAllProgram"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"programName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<GetAllProgramQuery, GetAllProgramQueryVariables>;
export const GetAllSportsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllSports"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAllSports"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"sportName"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<GetAllSportsQuery, GetAllSportsQueryVariables>;
export const CreateZoomTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateZoomToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateZoomToken"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createZoomToken"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"token"}}]}}]}}]} as unknown as DocumentNode<CreateZoomTokenMutation, CreateZoomTokenMutationVariables>;
export const CreateAssessmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateAssessment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateAssessmentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAssessment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"assessment"}}]}}]}}]} as unknown as DocumentNode<CreateAssessmentMutation, CreateAssessmentMutationVariables>;
export const GetLogInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLogInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getLogInfo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<GetLogInfoQuery, GetLogInfoQueryVariables>;
export const GetAllAssessmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllAssessment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAllAssessment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"assessment"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdById"}},{"kind":"Field","name":{"kind":"Name","value":"sessionId"}},{"kind":"Field","name":{"kind":"Name","value":"traineeId"}},{"kind":"Field","name":{"kind":"Name","value":"trainerId"}}]}}]}}]} as unknown as DocumentNode<GetAllAssessmentQuery, GetAllAssessmentQueryVariables>;
export const TrainerPaymentHistoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TrainerPaymentHistory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"trainerPaymentHistoryCountSearch2"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"trainerPaymentHistoryCountFilter2"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trainerPaymentHistory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"paidOn"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"sessionCount"}},{"kind":"Field","name":{"kind":"Name","value":"traineeName"}},{"kind":"Field","name":{"kind":"Name","value":"trainerName"}},{"kind":"Field","name":{"kind":"Name","value":"trainingType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}}]}},{"kind":"Field","name":{"kind":"Name","value":"transactionId"}},{"kind":"Field","name":{"kind":"Name","value":"trainerId"}},{"kind":"Field","name":{"kind":"Name","value":"trainingTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"sessionUniqId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trainerPaymentHistoryCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"trainerPaymentHistoryCountSearch2"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"trainerPaymentHistoryCountFilter2"}}}]}]}}]} as unknown as DocumentNode<TrainerPaymentHistoryQuery, TrainerPaymentHistoryQueryVariables>;
export const GetAllTrainerpaymentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllTrainerpayment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"getAllTrainerpaymentCountSearch2"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"getAllTrainerpaymentCountFilter2"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"formats"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAllTrainerpayment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"trainerId"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"paidOn"}},{"kind":"Field","name":{"kind":"Name","value":"trainerName"}},{"kind":"Field","name":{"kind":"Name","value":"programDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"programName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sessionStartTime"}},{"kind":"Field","name":{"kind":"Name","value":"sessionEndTime"}},{"kind":"Field","name":{"kind":"Name","value":"sessionTimeZone"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"traineeName"}},{"kind":"Field","name":{"kind":"Name","value":"trainingTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"trainingType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sessionUniqId"}},{"kind":"Field","name":{"kind":"Name","value":"sessionId"}},{"kind":"Field","name":{"kind":"Name","value":"transactionId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"sessionCount"}},{"kind":"Field","name":{"kind":"Name","value":"traineeIdUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"profileImage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"formats"},"value":{"kind":"Variable","name":{"kind":"Name","value":"formats"}}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"trainerIdUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"getAllTrainerpaymentCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"getAllTrainerpaymentCountSearch2"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"getAllTrainerpaymentCountFilter2"}}}]}]}}]} as unknown as DocumentNode<GetAllTrainerpaymentQuery, GetAllTrainerpaymentQueryVariables>;
export const DeleteUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reason"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"reason"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reason"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}}]}}]} as unknown as DocumentNode<DeleteUserMutation, DeleteUserMutationVariables>;
export const GetSessionByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSessionById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getSessionById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"sessionStartTime"}},{"kind":"Field","name":{"kind":"Name","value":"sessionEndTime"}},{"kind":"Field","name":{"kind":"Name","value":"sessionStatus"}},{"kind":"Field","name":{"kind":"Name","value":"programId"}},{"kind":"Field","name":{"kind":"Name","value":"sportId"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"programDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"programName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sessionUniqId"}},{"kind":"Field","name":{"kind":"Name","value":"assesment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"traineeId"}},{"kind":"Field","name":{"kind":"Name","value":"trainerId"}},{"kind":"Field","name":{"kind":"Name","value":"sessionId"}},{"kind":"Field","name":{"kind":"Name","value":"assessment"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"trainingType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trainerId"}},{"kind":"Field","name":{"kind":"Name","value":"trainerExpertiseRating"}},{"kind":"Field","name":{"kind":"Name","value":"trainerIdUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"about"}},{"kind":"Field","name":{"kind":"Name","value":"averageRating"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"profileImage"}},{"kind":"Field","name":{"kind":"Name","value":"specializations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"medias"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"traineeId"}},{"kind":"Field","name":{"kind":"Name","value":"traineeIdUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"ageRange"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"profileImage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"formats"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"edits"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"resize"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"160"}},{"kind":"ObjectField","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"160"}},{"kind":"ObjectField","name":{"kind":"Name","value":"fit"},"value":{"kind":"StringValue","value":"cover","block":false}}]}}]}}]}}]},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"weightType"}},{"kind":"Field","name":{"kind":"Name","value":"heightType"}},{"kind":"Field","name":{"kind":"Name","value":"fitnessGoals"}},{"kind":"Field","name":{"kind":"Name","value":"injury"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"preferredWorkouts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"equipments"}},{"kind":"Field","name":{"kind":"Name","value":"currentEngagements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workoutPreference"}}]}},{"kind":"Field","name":{"kind":"Name","value":"traineeRating"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}}]}}]}}]} as unknown as DocumentNode<GetSessionByIdQuery, GetSessionByIdQueryVariables>;
export const GetOverAllAssessmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOverAllAssessment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"traineeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getOverAllAssessment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"traineeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"traineeId"}}}]}]}}]} as unknown as DocumentNode<GetOverAllAssessmentQuery, GetOverAllAssessmentQueryVariables>;
export const GetOneSessionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOneSession"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getOneSession"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"sessionStartTime"}},{"kind":"Field","name":{"kind":"Name","value":"sessionEndTime"}},{"kind":"Field","name":{"kind":"Name","value":"lastTrainerDtls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"profileImage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assesment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"assessment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clientPerformance"}},{"kind":"Field","name":{"kind":"Name","value":"targetedMuscle"}},{"kind":"Field","name":{"kind":"Name","value":"clientFeedback"}},{"kind":"Field","name":{"kind":"Name","value":"exercisePerformed"}},{"kind":"Field","name":{"kind":"Name","value":"trainingType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trainerIdUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"profileImage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"formats"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"edits"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"resize"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"25"}},{"kind":"ObjectField","name":{"kind":"Name","value":"height"},"value":{"kind":"IntValue","value":"25"}},{"kind":"ObjectField","name":{"kind":"Name","value":"fit"},"value":{"kind":"StringValue","value":"cover","block":false}}]}}]}}]}}]},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"programName"}},{"kind":"Field","name":{"kind":"Name","value":"programId"}}]}}]}}]} as unknown as DocumentNode<GetOneSessionQuery, GetOneSessionQueryVariables>;
export const GetNotesFromPreviosSessionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetNotesFromPreviosSessions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"formats"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getNotesFromPreviosSessions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientFeedback"}},{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"sessionStartTime"}},{"kind":"Field","name":{"kind":"Name","value":"sessionEndTime"}},{"kind":"Field","name":{"kind":"Name","value":"trainerIdUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"profileImage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"formats"},"value":{"kind":"Variable","name":{"kind":"Name","value":"formats"}}}]},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}}]}}]} as unknown as DocumentNode<GetNotesFromPreviosSessionsQuery, GetNotesFromPreviosSessionsQueryVariables>;
export const CreateSessionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateSession"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateSessionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createSession"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}}]}}]} as unknown as DocumentNode<CreateSessionMutation, CreateSessionMutationVariables>;
export const UpdateSessionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateSession"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateSessionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateSession"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}}]}}]} as unknown as DocumentNode<UpdateSessionMutation, UpdateSessionMutationVariables>;
export const GetAllSessionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllSession"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAllSession"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"roomId"}},{"kind":"Field","name":{"kind":"Name","value":"sessionStartTime"}},{"kind":"Field","name":{"kind":"Name","value":"sessionEndTime"}},{"kind":"Field","name":{"kind":"Name","value":"sessionStatus"}},{"kind":"Field","name":{"kind":"Name","value":"sportId"}},{"kind":"Field","name":{"kind":"Name","value":"programId"}},{"kind":"Field","name":{"kind":"Name","value":"programName"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"sessionUniqId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"trainerAssignedDateTime"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"trainingType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}},{"kind":"Field","name":{"kind":"Name","value":"trainerId"}},{"kind":"Field","name":{"kind":"Name","value":"trainerIdUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"profileImage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastTrainerDtls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"profileImage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assesment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"assessment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"futureSessionImprovement"}},{"kind":"Field","name":{"kind":"Name","value":"targetedMuscle"}},{"kind":"Field","name":{"kind":"Name","value":"clientFeedback"}},{"kind":"Field","name":{"kind":"Name","value":"traineeId"}},{"kind":"Field","name":{"kind":"Name","value":"traineeIdUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"profileImage"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionType"}},{"kind":"Field","name":{"kind":"Name","value":"trainerExpertiseRating"}},{"kind":"Field","name":{"kind":"Name","value":"createdById"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"trainerFeedback"}},{"kind":"Field","name":{"kind":"Name","value":"clientPerformance"}},{"kind":"Field","name":{"kind":"Name","value":"exercisePerformed"}},{"kind":"Field","name":{"kind":"Name","value":"participantLogs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"LogType"}},{"kind":"Field","name":{"kind":"Name","value":"participantId"}},{"kind":"Field","name":{"kind":"Name","value":"time"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"getAllSessionCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}]}]}}]} as unknown as DocumentNode<GetAllSessionQuery, GetAllSessionQueryVariables>;
export const GetAllTrainingTypeSessionListingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllTrainingTypeSessionListing"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAllTrainingType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<GetAllTrainingTypeSessionListingQuery, GetAllTrainingTypeSessionListingQueryVariables>;
export const GetAllSessionsCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllSessionsCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAllSessionCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}]}]}}]} as unknown as DocumentNode<GetAllSessionsCountQuery, GetAllSessionsCountQueryVariables>;
export const QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Query"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAllTrainingTypeCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}]}]}}]} as unknown as DocumentNode<QueryQuery, QueryQueryVariables>;
export const GetSessionBalanceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSessionBalance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCurrentUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sessionBalance"}},{"kind":"Field","name":{"kind":"Name","value":"fitCurveBalance"}},{"kind":"Field","name":{"kind":"Name","value":"fitPrimeBalance"}},{"kind":"Field","name":{"kind":"Name","value":"fitVarsityBalance"}},{"kind":"Field","name":{"kind":"Name","value":"freeSessionBalance"}},{"kind":"Field","name":{"kind":"Name","value":"ageRange"}}]}}]}}]} as unknown as DocumentNode<GetSessionBalanceQuery, GetSessionBalanceQueryVariables>;
export const CardSetupIntentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CardSetupIntent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cardSetupIntent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setupIntentSecret"}},{"kind":"Field","name":{"kind":"Name","value":"stripeCustomerId"}}]}}]}}]} as unknown as DocumentNode<CardSetupIntentMutation, CardSetupIntentMutationVariables>;
export const ProductPaymentIntentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ProductPaymentIntent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductPaymentIntentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productPaymentIntent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentIntentSecret"}},{"kind":"Field","name":{"kind":"Name","value":"stripeCustomerId"}},{"kind":"Field","name":{"kind":"Name","value":"customerSessionSecret"}}]}}]}}]} as unknown as DocumentNode<ProductPaymentIntentMutation, ProductPaymentIntentMutationVariables>;
export const GetAllPurchaseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllPurchase"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAllPurchase"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"paymentDate"}},{"kind":"Field","name":{"kind":"Name","value":"transactionId"}},{"kind":"Field","name":{"kind":"Name","value":"sessionSubscribed"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"}},{"kind":"Field","name":{"kind":"Name","value":"programDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"programName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentMode"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"sessionCount"}},{"kind":"Field","name":{"kind":"Name","value":"localizedPrice"}},{"kind":"Field","name":{"kind":"Name","value":"currencyType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"getAllPurchaseCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}]}]}}]} as unknown as DocumentNode<GetAllPurchaseQuery, GetAllPurchaseQueryVariables>;
export const GetAllPlanDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllPlan"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAllPlan"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recommendedNoOfDays"}},{"kind":"Field","name":{"kind":"Name","value":"originalPrice"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"sessionCount"}},{"kind":"Field","name":{"kind":"Name","value":"planName"}},{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"program"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"programName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product_id"}}]}}]}}]} as unknown as DocumentNode<GetAllPlanQuery, GetAllPlanQueryVariables>;
export const GetMySavedCardsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMySavedCards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getMySavedCards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stripeCustomerId"}},{"kind":"Field","name":{"kind":"Name","value":"cards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"expMonth"}},{"kind":"Field","name":{"kind":"Name","value":"expYear"}},{"kind":"Field","name":{"kind":"Name","value":"last4"}}]}}]}}]}}]} as unknown as DocumentNode<GetMySavedCardsQuery, GetMySavedCardsQueryVariables>;